app.controller('NewBookingController', ['$scope', 'dataShare', '$location', '$http', '$window', '$routeParams', '$translate', 'getServicesAndProducts', 'Backend', '$timeout', '$filter', function ($scope, dataShare, $location, $http, $window, $routeParams, $translate, getServicesAndProducts, Backend, $timeout, $filter) {

    $scope.infoData = infoData;
    $scope.Language = infoData.Country;
    $scope.success = false;
    $scope.currentStep = 1;
    $scope.ready = false;

    $scope.booked = [];
    $scope.orderInfo = {};
    $scope.orderInfo.Time = '';
    $scope.orderInfo.Discount = false;
    $scope.orderInfo.People = 0;
    $scope.orderInfo.ParentsAttending = 0;
    $scope.orderInfo.deposit = false;
    $scope.orderInfo.TotalPrice = 0;
    $scope.orderInfo.TotalPriceWT = 0;
    $scope.orderInfo.TotalPriceDisc = 0;
    $scope.orderInfo.TotalPriceDiscWT = 0;
    $scope.orderInfo.Comment = '';
    $scope.orderInfo.addonsSum = 0;
    $scope.orderInfo.addonsSumWT = 0;
    $scope.orderInfo.Schedules = [];
    $scope.orderInfo.GymID = infoData.GymID;
    $scope.orderInfo.NameSpace = infoData.NameSpace;
    $scope.logo = logo;
    if(isBirthday != null)
        $scope.isBirthday = isBirthday;

    var namespace = infoData.NameSpace;
    $scope.onlyEarnest = infoData.Settings.OnlyEarnest;
    $scope.OnlineBookingTaxText = infoData.Settings.OnlineBookingTaxText;
    $scope.ShowCapacitySingleVisits = infoData.Settings.ShowCapacitySingleVisits;
    $scope.daysAheadBooking = (infoData.Settings.HoursAheadBooking == 0) ? null : infoData.Settings.HoursAheadBooking;
    $scope.Currency = infoData.Currency;

    if (customCurrency ){
        $scope.customCurrency = customCurrency;
    }

    var $translateThis = $filter('translate');
    
    $scope.TelephoneNumberOptional = infoData.Settings.TelephoneNumberOptional;
    $scope.TelephoneNumberOptional = false;
    $scope.orderInfo.Earnest = infoData.Settings.Earnest;
    $scope.orderInfo.OnlineBookingWhatToWear = '';

    $scope.orderInfo.Areas = new Array();
    $scope.orderInfo.Time = '';
    $scope.orderInfo.PriceWithoutTax = '';
    $scope.orderInfo.VisitName = '';
    $scope.showCart = false;
    $scope.showAddOn = false;
    $scope.noHours = false;
    $scope.notEnoughSlots = false;
    $scope.notReachMinimumSlots = false;
    $scope.vaapShow = false;
    $scope.newBookingBirthday = false;
    $scope.newBookingVisit = false;
    $scope.newBookingBirthdayBooked = false;
    $scope.checkedBeforeAddtoCard = false;
    $scope.showFullPrice = infoData.Settings.ShowFullPrices;
    $scope.WarningText = infoData.Settings.WarningText;
    $scope.orderInfo.newbooking = true;
    $scope.orderInfo.ExtraProducts = [];
    $scope.orderInfo.ExtraVisits = [];
    $scope.orderInfo.receiveEmails = false;
    $scope.emailFormat = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-_]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
    $scope.phoneFormat = gym[0].Culture.includes('GB') ? /^[0-9]{5,11}$/ : /^[0-9]{5,15}$/;
    $scope.oneVisit = false;
    if( client != null ){
        $scope.client = client;

    }

    if(mainCategories){
        $scope.mainCategories = mainCategories;
    }

    if(mainSubCategories){
        $scope.mainSubCategories = mainSubCategories;
    }

    $scope.translateLangs = [];

    const timeZones = ["Europe/Andorra","Asia/Dubai","Asia/Kabul","Europe/Tirane","Asia/Yerevan","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia","Pacific/Pago_Pago","Europe/Vienna","Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla","Asia/Baku","America/Barbados","Asia/Dhaka","Europe/Brussels","Europe/Sofia","Atlantic/Bermuda","Asia/Brunei","America/La_Paz","America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco","America/Nassau","Asia/Thimphu","Europe/Minsk","America/Belize","America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Atikokan","America/Winnipeg","America/Rainy_River","America/Resolute","America/Rankin_Inlet","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","America/Dawson","America/Vancouver","Indian/Cocos","Europe/Zurich","Africa/Abidjan","Pacific/Rarotonga","America/Santiago","America/Punta_Arenas","Pacific/Easter","Asia/Shanghai","Asia/Urumqi","America/Bogota","America/Costa_Rica","America/Havana","Atlantic/Cape_Verde","America/Curacao","Indian/Christmas","Asia/Nicosia","Asia/Famagusta","Europe/Prague","Europe/Berlin","Europe/Copenhagen","America/Santo_Domingo","Africa/Algiers","America/Guayaquil","Pacific/Galapagos","Europe/Tallinn","Africa/Cairo","Africa/El_Aaiun","Europe/Madrid","Africa/Ceuta","Atlantic/Canary","Europe/Helsinki","Pacific/Fiji","Atlantic/Stanley","Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae","Atlantic/Faroe","Europe/Paris","Europe/London","Asia/Tbilisi","America/Cayenne","Africa/Accra","Europe/Gibraltar","America/Nuuk","America/Danmarkshavn","America/Scoresbysund","America/Thule","Europe/Athens","Atlantic/South_Georgia","America/Guatemala","Pacific/Guam","Africa/Bissau","America/Guyana","Asia/Hong_Kong","America/Tegucigalpa","America/Port-au-Prince","Europe/Budapest","Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura","Europe/Dublin","Asia/Jerusalem","Asia/Kolkata","Indian/Chagos","Asia/Baghdad","Asia/Tehran","Atlantic/Reykjavik","Europe/Rome","America/Jamaica","Asia/Amman","Asia/Tokyo","Africa/Nairobi","Asia/Bishkek","Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati","Asia/Pyongyang","Asia/Seoul","Asia/Almaty","Asia/Qyzylorda","Asia/Qostanay","Asia/Aqtobe","Asia/Aqtau","Asia/Atyrau","Asia/Oral","Asia/Beirut","Asia/Colombo","Africa/Monrovia","Europe/Vilnius","Europe/Luxembourg","Europe/Riga","Africa/Tripoli","Africa/Casablanca","Europe/Monaco","Europe/Chisinau","Pacific/Majuro","Pacific/Kwajalein","Asia/Yangon","Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan","Asia/Macau","America/Martinique","Europe/Malta","Indian/Mauritius","Indian/Maldives","America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Bahia_Banderas","Asia/Kuala_Lumpur","Asia/Kuching","Africa/Maputo","Africa/Windhoek","Pacific/Noumea","Pacific/Norfolk","Africa/Lagos","America/Managua","Europe/Amsterdam","Europe/Oslo","Asia/Kathmandu","Pacific/Nauru","Pacific/Niue","Pacific/Auckland","Pacific/Chatham","America/Panama","America/Lima","Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier","Pacific/Port_Moresby","Pacific/Bougainville","Asia/Manila","Asia/Karachi","Europe/Warsaw","America/Miquelon","Pacific/Pitcairn","America/Puerto_Rico","Asia/Gaza","Asia/Hebron","Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores","Pacific/Palau","America/Asuncion","Asia/Qatar","Indian/Reunion","Europe/Bucharest","Europe/Belgrade","Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Kirov","Europe/Volgograd","Europe/Astrakhan","Europe/Saratov","Europe/Ulyanovsk","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Barnaul","Asia/Tomsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Ust-Nera","Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr","Asia/Riyadh","Pacific/Guadalcanal","Indian/Mahe","Africa/Khartoum","Europe/Stockholm","Asia/Singapore","America/Paramaribo","Africa/Juba","Africa/Sao_Tome","America/El_Salvador","Asia/Damascus","America/Grand_Turk","Africa/Ndjamena","Indian/Kerguelen","Asia/Bangkok","Asia/Dushanbe","Pacific/Fakaofo","Asia/Dili","Asia/Ashgabat","Africa/Tunis","Pacific/Tongatapu","Europe/Istanbul","America/Port_of_Spain","Pacific/Funafuti","Asia/Taipei","Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye","Pacific/Wake","America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Anchorage","America/Juneau","America/Sitka","America/Metlakatla","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu","America/Montevideo","Asia/Samarkand","Asia/Tashkent","America/Caracas","Asia/Ho_Chi_Minh","Pacific/Efate","Pacific/Wallis","Pacific/Apia","Africa/Johannesburg","America/Antigua","America/Anguilla","Africa/Luanda","Antarctica/McMurdo","America/Aruba","Europe/Mariehamn","Europe/Sarajevo","Africa/Ouagadougou","Asia/Bahrain","Africa/Bujumbura","Africa/Porto-Novo","America/St_Barthelemy","America/Kralendijk","Africa/Gaborone","Africa/Kinshasa","Africa/Lubumbashi","Africa/Bangui","Africa/Brazzaville","Africa/Douala","Europe/Busingen","Africa/Djibouti","America/Dominica","Africa/Asmara","Africa/Addis_Ababa","Africa/Libreville","America/Grenada","Europe/Guernsey","Africa/Banjul","Africa/Conakry","America/Guadeloupe","Africa/Malabo","Europe/Zagreb","Europe/Isle_of_Man","Europe/Jersey","Asia/Phnom_Penh","Indian/Comoro","America/St_Kitts","Asia/Kuwait","America/Cayman","Asia/Vientiane","America/St_Lucia","Europe/Vaduz","Africa/Maseru","Europe/Podgorica","America/Marigot","Indian/Antananarivo","Europe/Skopje","Africa/Bamako","Pacific/Saipan","Africa/Nouakchott","America/Montserrat","Africa/Blantyre","Africa/Niamey","Asia/Muscat","Africa/Kigali","Atlantic/St_Helena","Europe/Ljubljana","Arctic/Longyearbyen","Europe/Bratislava","Africa/Freetown","Europe/San_Marino","Africa/Dakar","Africa/Mogadishu","America/Lower_Princes","Africa/Mbabane","Africa/Lome","Africa/Dar_es_Salaam","Africa/Kampala","Pacific/Midway","Europe/Vatican","America/St_Vincent","America/Tortola","America/St_Thomas","Asia/Aden","Indian/Mayotte","Africa/Lusaka","Africa/Harare" ]

    let timezoneP = $scope.infoData.TimeZoneKey.split(') ');
    let timezonePi = timezoneP[1].split(',');
    let timeZoneC = timezonePi[0];
    let timeZoneF = timeZones.find(el => el.includes(timeZoneC)); 

    let timeZoneOffsetSplit = timezoneP[0].split('UTC');
    $scope.timeZoneOffset = timeZoneOffsetSplit[1];

    moment.tz.setDefault(timeZoneF);

    function roundTo(value, decimals) {
        return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    }
    
    if (gym) {
		$scope.gym = gym;
		$($scope.gym[0].BODYPart).prependTo('.body-scripts');
        $($scope.gym[0].HEADPart).appendTo(document.head);
    }

    $('.login-nav i.login-icon').on('click', function(){
        if(client){
            $('.header').toggleClass('show-login-menu');
        }else{
            $scope.loginModal();
        }

        if($('.header').is('.show-lang-menu'))
            $('.header').toggleClass('show-lang-menu');
    })

    $scope.legalAge = 21;
    if ( legalAge != 0 && legalAge != null ) {
        $scope.legalAge = legalAge;
        $scope.legalAge += 1;
    }

    var newMozDate = new Date();
    $scope.newMozDate = newMozDate;

    var currentYear = new Date().getFullYear();
    $scope.dateYears = [];
    startYear = currentYear - $scope.legalAge;

    while (startYear <= currentYear) {
        $scope.dateYears.push(startYear++);
    }

    var data = dataShare.getData();
    $scope.adds = data.addons;

    $scope.showAddOn = false;

    $scope.BookingOpenAfter = infoData.Settings.BookingOpenAfter;
    $scope.PartyBookingOpenAfter = infoData.Settings.PartyBookingOpenAfter;

    if (infoData.Country.indexOf('enu') > -1 || infoData.Country.indexOf('ius') > -1) {
        $scope.usTime = true;
        $scope.dateFormat = 'MM.DD.YYYY';
        $scope.timeFormat = 'hh:mm a'; // used when parsing times from the backend
        $scope.timePrintFormat = 'hh:mm a';
        $scope.dateTimeFormat = 'MM-DD-YYYY hh:mm a';
    }
    else {
        $scope.usTime = false;
        $scope.dateFormat = 'DD.MM.YYYY';
        $scope.timeFormat = 'HH:mm'; // used when parsing times from the backend
        $scope.timePrintFormat = 'HH:mm [h]';
        $scope.dateTimeFormat = 'DD.MM.YYYY HH:mm [h]';
    }


    var plusClickTimer = 0;
    var plusClicked = false;

    $scope.plus = function (item) {

        if(item.Quantity < $scope.maxQuantity){
            item.Quantity++;
            $('.sessions-list .item.expanded').removeClass('loaded');

            if (!plusClicked) {
                plusClickTimer = setTimeout(() => $scope.calculatePrice(item), 2000);
                plusClicked = true;
            }else{
                clearTimeout (plusClickTimer);
                plusClickTimer = setTimeout(() => $scope.calculatePrice(item), 2000);
            }
        }
    };

    $scope.minus = function (item) {
        if (item.Quantity != 1) {
            if (item.PeopleQuantity == item.Quantity) {
                item.PeopleQuantity--;
            }
            item.Quantity--;
        }
        $('.sessions-list .item.expanded').removeClass('loaded');

        if (!plusClicked) {
            plusClickTimer = setTimeout(() => $scope.calculatePrice(item), 2000);
            plusClicked = true;
        }else{
            clearTimeout (plusClickTimer);
            plusClickTimer = setTimeout(() => $scope.calculatePrice(item), 2000);
        }
    };

    $scope.plusP = function (item) {
        if (item.PeopleQuantity < item.Quantity) {
            item.PeopleQuantity++;
        }
    };
    $scope.minusP = function (item) {
        if (item.PeopleQuantity != 1) {
            item.PeopleQuantity--;
        }
    };


    manageItemDiscounts = (item) => {
        if(!item.OnlineBookingBirthday){
            $scope.category = getDiscCategory(item.ServiceCategoryID);
        }
        if (item.MinimalPackagePriceByPeople > 0) {
            item.PriceTotal = item.MinimalPackagePriceByPeople;
            item.PriceTotalWithoutTax = item.MinimalPackagePriceByPeopleWithoutTax;

            if (item.Quantity >= item.MinimalPackagePeople) {
                item.PriceTotal += (item.Quantity - item.MinimalPackagePeople) * item.TotalPrice;
                item.PriceTotalWithoutTax += (item.Quantity - item.MinimalPackagePeople) * item.PriceWithoutTax;
            }
        }
        else {
            item.PriceTotal = item.Quantity * item.TotalPrice;
            item.PriceTotalWithoutTax = item.Quantity * item.PriceWithoutTax;
        }
        
        if(item.OnlineBookingMinPeopleForDiscount > 0 && !item.OnlineBookingCategoryDiscount){
            if (item.Quantity > item.OnlineBookingMinPeopleForDiscount) {
                if (item.MinimalPackagePriceByPeople > 0) {
                    if (item.OnlineBookingMinPeopleForDiscount <= item.Quantity) {
                        var peopleToDiscount = item.Quantity - item.OnlineBookingMinPeopleForDiscount + 1;
                        item.PriceTotal = item.PriceTotal - (item.PriceWithoutTax * peopleToDiscount * (item.OnlineBookingDiscount / 100));
                        item.PriceTotalWithoutTax = item.PriceTotal;
                        item.PriceCurrent = item.Price1 - (item.Price1 * (item.OnlineBookingDiscount / 100));
                        item.OnlineBookingDiscountPrice = ((item.OnlineBookingDiscount/100)*item.Price1) * peopleToDiscount;
                        $scope.orderInfo.Discount = true;
                        item.quantityDiscount = true;
                    }
                }
                else {
                    item.PriceTotal = item.PriceTotal - (item.PriceTotal * (item.OnlineBookingDiscount / 100));
                    item.PriceTotalWithoutTax = item.PriceTotalWithoutTax - (item.PriceTotalWithoutTax * (item.OnlineBookingDiscount / 100));
                    item.PriceCurrent = item.Price1 - (item.Price1 * (item.OnlineBookingDiscount / 100));
                    item.OnlineBookingDiscountPrice = ((item.OnlineBookingDiscount/100)*item.Price1)*item.Quantity;
                    $scope.orderInfo.Discount = true;
                    item.quantityDiscount = true;
                    $scope.orderInfo.PriceWithTax = item.PriceWithoutTax - (item.PriceWithoutTax * (item.OnlineBookingDiscount / 100));
                }
            }else{
                item.PriceCurrent = item.Price1;
                $scope.orderInfo.Discount = false;
                item.quantityDiscount = false;
                $scope.orderInfo.PriceWithTax = item.PriceWithoutTax;
            }
        }
        else{
            $scope.orderInfo.Discount = false;
            item.quantityDiscount = false;
            item.PriceTotal = item.PriceTotal;
            item.PriceTotalWithoutTax = item.PriceTotalWithoutTax;   
        }

        if($scope.category && ( $scope.category.Discounts && $scope.category.Discounts.length > 0 )) {
            let quantity = $scope.category.Quantity > 0 ? ($scope.category.Quantity+item.Quantity) : item.Quantity;
            let catOnlineBookingDiscount = getDiscountByQuantity(quantity, $scope.category.Discounts);

            if (catOnlineBookingDiscount > 0) {
                item.OnlineBookingDiscount = catOnlineBookingDiscount;
                item.OnlineBookingDiscountPrice = (item.OnlineBookingDiscount/100)*item.PriceTotal;
                item.PriceCurrent = item.Price1 - (item.Price1 * (item.OnlineBookingDiscount / 100));
                item.PriceTotal = item.PriceTotal - (item.PriceTotal * (item.OnlineBookingDiscount / 100));
                item.PriceTotalWithoutTax = item.PriceTotalWithoutTax - (item.PriceTotalWithoutTax * (item.OnlineBookingDiscount / 100));
                $scope.orderInfo.PriceWithTax = item.PriceWithoutTax - (item.PriceWithoutTax * (item.OnlineBookingDiscount / 100));
                item.OnlineBookingCategoryDiscount = true;
                $scope.orderInfo.Discount = true;
            }else{
                item.OnlineBookingCategoryDiscount = false;
                item.OnlineBookingDiscountPrice = 0;
                item.PriceTotal = item.Quantity * item.TotalPrice;
                $scope.orderInfo.Discount = false;
                item.PriceCurrent = item.Price1;
            }
        }
    }

    getDiscountByQuantity = (quantity, discounts) => {
        let disc;
        let finalDiscount;

        for (var i = 0; i < discounts.length; i++) {
            if ( quantity >= discounts[i].NumberOfVisits) {
                disc = discounts[i];
            }
        }

        finalDiscount = disc ? disc.Discount : 0;
        return finalDiscount;
    }

    $scope.calculatePrice = async function (item) {
        $('.sessions-list .item.expanded').removeClass('loaded');

        manageItemDiscounts(item)

        $scope.selectedIndex = -1;
        if( $scope.selectedIndex >= 0 ){
            $scope.compare($scope.selectedIndex);
        }

        $scope.minBookableTime = $scope.newBookingBirthday ? moment().add($scope.PartyBookingOpenAfter, 'hours') : moment().add($scope.BookingOpenAfter, 'hours');

        var now = new Date($scope.minBookableTime);

        if ($scope.minDate)
            now = $scope.minDate

        if ($scope.currentDate != undefined)
            now = $scope.currentDate > now ? $scope.currentDate : now;

        if ($scope.currentTempDate != undefined)
            now = $scope.currentTempDate;

        var numberDay = moment(now).format('e');
        var ree = $.grep($scope.visit.visitRealHours, function (e) { return e.day == numberDay; });
        $scope.realHours = [];
        if (ree != undefined && ree.length > 0) {
            for (i = 0; i < ree[0].hours[0].length; i++) {

                var justDate = moment(now).startOf('day');
                var justTime = moment(ree[0].hours[0][i], $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                if (moment(dateTime).isAfter($scope.minBookableTime)) {
                    $scope.realHours.push(ree[0].hours[0][i]);
                }
            }
        }

        if (!$scope.dontCallCheckConflict && !$scope.checkedBeforeAddtoCard) {
            // setTimeout(function() {
            // }, 500);
            await checkConflict(now);
        }

        if($scope.checkedBeforeAddtoCard){
            $('.sessions-list').removeClass('loading');
            $('.sessions-list .item.expanded').addClass('loaded');
            $scope.checkedBeforeAddtoCard = false;
        }

        $scope.ready = false;
        $scope.notEnoughSlots = false;
        $scope.notReachMinimumSlots = false;

    }

    $scope.calculatePeople = function(item){
        if (item.PeopleQuantity > item.Quantity)
            item.PeopleQuantity = item.Quantity
    }

    if (infoData.Country.indexOf('enu') > -1 || infoData.Country.indexOf('ius') > -1) {
        $scope.usTime = true;
        $scope.dateFormat = 'MM.DD.YYYY';
        $scope.timeFormat = 'hh:mm a'; // used when parsing times from the backend
        $scope.timePrintFormat = 'hh:mm a';
        $scope.dateTimeFormat = 'MM-DD-YYYY hh:mm a';
    }
    else {
        $scope.usTime = false;
        $scope.dateFormat = 'DD.MM.YYYY';
        $scope.timeFormat = 'HH:mm'; // used when parsing times from the backend
        $scope.timePrintFormat = 'HH:mm [h]';
        $scope.dateTimeFormat = 'DD.MM.YYYY HH:mm [h]';
    }

    $scope.filterCategory = function(id, subCategory = false){

        $('.step-lists').addClass('loading');
        $('.step-lists li[data-id="' + id + '"]').addClass('active').siblings().removeClass('active');

        if(subCategory){
            filteredSubCatID = id;
            filteredCatID = null;
        }else{
            filteredCatID = id;
            filteredSubCatID = null;
        }

        getServicesAndProducts.async().then(function (d) {
            console.log(d);
            $scope.visits = d.SingleVisitsMain;
            $scope.visits = $scope.visits.concat(d.SingleVisitsSub);
            $scope.birthdays = d.MainServices;
            $scope.categories = d.Categories;
    
            // for (var i = 0; i < $scope.birthdays.length; i++) {
            //     if ($scope.birthdays[i].OnlineBookingMinPeopleForDiscount != 0)
            //         $scope.birthdays[i].OnlineBookingMinPeopleForDiscount++;
            // }
    
            for (var i = 0; i < $scope.categories.length; i++) {
                $scope.categories[i]['Quantity'] = 0;
            }

            $('.step-lists').removeClass('loading');

        });
    }

    getServicesAndProducts.async().then(function (d) {
        $scope.visits = d.SingleVisitsMain;
        $scope.visits = $scope.visits.concat(d.SingleVisitsSub);
        $scope.birthdays = d.MainServices;
        $scope.singleAddOns = d.SingleVisitsAddons;
        $scope.groupAddOns = d.OnlineProducts;
        $scope.groupAddOns = $scope.groupAddOns.concat(d.SubServices);
        $scope.categories = d.Categories;

        for (var i = 0; i < $scope.birthdays.length; i++) {
            let birtday = $scope.birthdays[i];
            // if (birtday.OnlineBookingMinPeopleForDiscount != 0)
            //     birtday.OnlineBookingMinPeopleForDiscount++;
            birtday.PriceWithoutTax = roundTo(birtday.PriceWithoutTax, 2);

            if (birtday.OnlineBookingDiscount != 0)
                birtday.OnlineBookingDiscountPrice = (birtday.OnlineBookingDiscount/100)*birtday.TotalPrice;
        }

        for (var i = 0; i < $scope.visits.length; i++) {
            let visit = $scope.visits[i];
            visit.PriceWithoutTax = roundTo(visit.PriceWithoutTax, 2);

            if (visit.OnlineBookingDiscount != 0)
            visit.OnlineBookingDiscountPrice = (visit.OnlineBookingDiscount/100)*visit.TotalPrice;
        }

        for (var i = 0; i < $scope.singleAddOns.length; i++) {
            $scope.singleAddOns[i]['Quantity'] = 0;
            $scope.singleAddOns[i]['PriceWithoutTax'] = roundTo($scope.singleAddOns[i]['PriceWithoutTax'], 2);
        }

        for (var i = 0; i < $scope.groupAddOns.length; i++) {
            $scope.groupAddOns[i]['Quantity'] = 0;

            if ($scope.groupAddOns[i]['ProductName']) {
                $scope.groupAddOns[i]['VisitName'] = $scope.groupAddOns[i]['ProductName'];
            }

            if ( $scope.groupAddOns[i]['PriceSell'] >= 0 ) {
                $scope.groupAddOns[i]['TotalPrice'] = $scope.groupAddOns[i]['PriceSell'];
            }

            if ($scope.groupAddOns[i]['ProductID']) {
                $scope.groupAddOns[i]['VisitDefinitionID'] = $scope.groupAddOns[i]['ProductID'];
            }
        }

        for (var i = 0; i < $scope.categories.length; i++) {
            $scope.categories[i]['Quantity'] = 0;
        }

        visitDefinitionPredefined();
    });


    $scope.changeStep = function (n, v) {
        if ( $scope.currentStep == 3 && n == 2 && $scope.vaapShow == true) {
            $scope.vaapShow = false
            return;
        }

        if ($scope.currentStep == 4 && n == 3) {
            $timeout(function() {
                $scope.orderInfo.PaymentType = null;
            }, 100);   
        }
        
        if (n == 1) {
            orderInfoReset();
        }

        if (n == 3 && ( ($scope.newBookingBirthday && $scope.groupAddOns.length > 0) || ($scope.newBookingVisit && $scope.singleAddOns.length > 0)) && $scope.showAddOn == false) {
            $scope.showAddOn = true;
            $(window).scrollTop(0);
        } else {
            $(window).scrollTop(0);
            $scope.currentStep = n;
        }

        if (v == 1) {
            $scope.newBookingBirthday = true;
            $scope.newBookingVisit = false;
            $scope.showAddOn = false;
        } else if (v == 2) {
            $scope.newBookingVisit = true;
            $scope.newBookingBirthday = false;
            $scope.showAddOn = false;
        }

        if (n == 4 || n == 1 || n == 5) {
            $('.neworder-wrapper').addClass('hide-cart');

            if(redirected && sessionStorage.orderinfo){
                $('body').addClass('loaded');
                sessionStorage.clear();
            }
        }else {
            $('.neworder-wrapper.hide-cart').removeClass('hide-cart');
        }

        if (n == 4 && $scope.orderInfo.OnlineBookingWhatToWear) {
            $scope.whatToWearPopup();
        }

        if (v == 5) {
            $scope.newBookingBirthday = true;
            $scope.newBookingVisit = false;
            $scope.showAddOn = false;
        }

        if(n == 2){
            if( client != null ){
                if($scope.newBookingBirthday || $scope.infoData.Settings.SingleVisitChildInput){
                    $scope.orderInfo.EmergencyName1 = client.FirstName;
                    $scope.orderInfo.EmergencyName2 = client.LastName;
                }else{
                    $scope.orderInfo.FirstName = client.FirstName;
                    $scope.orderInfo.LastName = client.LastName;
                }
                $scope.orderInfo.Email = client.Email;
            }
        }

        $('body').removeClass('show-shopping-cart');
    }

    if ( isBirthday == true ){
        $scope.changeStep(2, 1);
    }else if ( isBirthday == false ){
        $scope.changeStep(2, 2);
    }

    if( $scope.infoData.Settings.HideBirthdayBooking ){
        $scope.changeStep(2, 2);
    }

    $scope.nextStep = function () {

        if ( $scope.currentStep == 4 ) {
            $('body').removeClass('show-shopping-cart');
            // $scope.showCart = false;
        }else{
            if ($scope.currentStep == 3 && $scope.vaapShow == false) {
                if (!$scope.formRegister.$invalid) {
                    $scope.sendData()
                }
            } else if ( $scope.currentStep == 3 && $scope.vaapShow == true ) {
                if ( !$scope.formVaap.$invalid ) {
                    $scope.changeStep($scope.currentStep + 1);
                }
            }else{
                $scope.changeStep($scope.currentStep + 1);
            }
        }
    }

    $(document).on('click', '.sessions-list .item-header', function () {
        var item = $(this).parent('.item');
        $scope.ready = false;
        $scope.showAddOn = false;
        $scope.noHours = false;
        $scope.curHours = [];
        $scope.visit = false;
        $scope.seemore = false
        $scope.minBookableTime = $scope.newBookingBirthday ? moment().add($scope.PartyBookingOpenAfter, 'hours') : moment().add($scope.BookingOpenAfter, 'hours');
        var now = new Date($scope.minBookableTime);
        // $scope.currentDate = now;
        $scope.currentDate = $scope.currentDate > now ? $scope.currentDate : now;
        // $scope.$apply();

        if (!item.is('.expanded')) {
            item.addClass('expanded').siblings().removeClass('expanded loaded');
            // item.find('.item-quantity').val('1');
            $scope.getVisitHours(item.data('itemid'));
            $scope.selectedIndex = -1;


            if ( $scope.newBookingBirthday == true && $scope.orderInfo.Schedules.length > 0){
                $scope.newBookingBirthdayBooked = true;
            }
        } else {
            item.removeClass('expanded loaded');
        }
    })

    $scope.seemore = false
    $scope.seeMore = function(seemore){
        $scope.seemore = seemore;
    }

    discountSchedule = () => {
        for (var i = 0; i < $scope.categories.length; i++) {
            if ( $scope.categories[i].Quantity > 0 ) {
                let discount = getDiscountByQuantity($scope.categories[i].Quantity, $scope.categories[i].Discounts);
                let scheduleItems = $.grep($scope.orderInfo.Schedules, function (e) { return e.ServiceCategoryID == $scope.categories[i].Id; });

                for (var n = 0; n < scheduleItems.length; n++) {
                    if(scheduleItems[n].OnlineBookingCategoryDiscount){   
                        if (discount > 0) {
                            scheduleItems[n].Price = (scheduleItems[n].Price1 - (scheduleItems[n].Price1 / 100 * discount));
                            scheduleItems[n].PriceTotalWithoutTax = (scheduleItems[n].PriceWithoutTax - (scheduleItems[n].PriceWithoutTax / 100 * discount)) * scheduleItems[n].PeopleAttending;
                            scheduleItems[n].PriceTotal = (scheduleItems[n].Price1 - (scheduleItems[n].Price1 / 100 * discount))  * scheduleItems[n].PeopleAttending;
                            scheduleItems[n].Discount = true;
                            scheduleItems[n].OnlineBookingCategoryDiscount = true;
                            scheduleItems[n].OnlineBookingDiscount = discount;   
                            scheduleItems[n].OnlineBookingDiscountPrice = ((discount/100)*scheduleItems[n].Price1)*scheduleItems[n].PeopleAttending;
                        }else{
                            scheduleItems[n].Price = scheduleItems[n].Price1;
                            if (scheduleItems[n].PeopleAttending >= scheduleItems[n].MinimalPackagePeople) {
                                scheduleItems[n].PriceTotal = (scheduleItems[n].PeopleAttending - scheduleItems[n].MinimalPackagePeople) * scheduleItems[n].Price1;
                                scheduleItems[n].PriceTotalWithoutTax = (scheduleItems[n].PeopleAttending - scheduleItems[n].MinimalPackagePeople) * scheduleItems[n].PriceWithoutTax;
                            }
                            // scheduleItems[n].PriceTotalWithoutTax = scheduleItems[n].PriceWithoutTax * scheduleItems[n].PeopleAttending;
                            // scheduleItems[n].PriceTotal = scheduleItems[n].Price1  * scheduleItems[n].PeopleAttending;
                            scheduleItems[n].Discount = false;
                            scheduleItems[n].OnlineBookingCategoryDiscount = false;
                        }

                    }

                    let bookedItem = $.grep($scope.booked, function (e) { return e.UniqueID == scheduleItems[n].UniqueID; });
                    if ( bookedItem ) {
                        bookedItem[0].PriceTotalWithoutTax = scheduleItems[n].PriceTotalWithoutTax;
                        bookedItem[0].PriceTotal = scheduleItems[n].PriceTotal;
                        bookedItem[0].OnlineBookingDiscount = scheduleItems[n].OnlineBookingDiscount;
                        bookedItem[0].OnlineBookingDiscountPrice = scheduleItems[n].OnlineBookingDiscountPrice;
                    }
                }
            }
        }
    }

    getDiscCategory = (visitCategoryID) => {
        const category = $.grep($scope.categories, function (e) { return e.Id == visitCategoryID; });
        return category[0] || false;
    }

    addQuantityToDiscCat = (categoryId, quantity) => {
        let cat = getDiscCategory(categoryId);
        cat.Quantity += cat ? quantity : 0;
    }

    removeQuantityFromDiscCat = (categoryId, quantity) => {
        let cat = getDiscCategory(categoryId);
        cat.Quantity -= cat ? quantity : 0;
    }

    $scope.getVisitHours = async function (visitID) {
        $scope.noHours = true;
        $scope.currentVisitId = visitID;
        $scope.orderInfo.id = visitID;

        if ($scope.newBookingBirthday == true) {
            var visitResult = $.grep($scope.birthdays, function (e) { return e.VisitDefinitionID == visitID; });
        } else {
            var visitResult = $.grep($scope.visits, function (e) { return e.VisitDefinitionID == visitID; });
        }
        $scope.visit = visitResult[0];
        let visit = $scope.visit;

        if(!visit.OnlineBookingBirthday){
            $scope.category = getDiscCategory(visit.ServiceCategoryID);
        }

        if ($scope.visit.OnlineBookingDaysOfWeek){
            $scope.visit.offDays = $scope.visit.OnlineBookingDaysOfWeek.split(',').map(function (offDay) { return parseInt(offDay, 10); });//[1, 3, 4];
        }else{
            $scope.visit.offDays = 'all';
        }

        //setup before functions
        var typingPeople;
        var $inputPeople = $('.neworder-wrapper.newbooking .sessions-list .item.expanded .actions .field-wrap .item-quantity');

        //on keyup, start the countdown
        $inputPeople.on('keyup', function () {
            clearTimeout(typingPeople);

            if($inputPeople[0].value > $scope.maxQuantity)
                $inputPeople[0].value = $scope.maxQuantity
            typingPeople = setTimeout(function() {$scope.calculatePrice($scope.visit)}, 2000);
        });

        //on keydown, clear the countdown 
        $inputPeople.on('keydown', function () {
            clearTimeout(typingPeople);
          
            $('.sessions-list .item.expanded').removeClass('loaded');
        });

        $scope.orderInfo.OnlineBookingMinPeopleForEvent = $scope.visit.OnlineBookingMinPeopleForEvent;

        if ($scope.visit.PriceWithoutTax == 0 || $scope.visit.PriceWithoutTax == null)
            $scope.visit.PriceWithoutTax = $scope.visit.TotalPrice;

        
        var visitHours = [];
        var vHours = $scope.visit.OnlineBookingHours;
        var d = moment('2011-11-11'); 

        $.each(vHours, function (index, value) {
            var self = $(this);
            var hours = [];

            $.each(self[0].Hours, function (index, value) {
                var innerSelf = $(this);
                var newDateObj = moment(d).add(innerSelf[0].Time.TotalMinutes, 'm').format('HH:mm');
                hours.push(newDateObj);
            });

            var oned = { day: self[0].DayOfWeek, hours: [hours] };

            visitHours.push(oned);

        });

        $scope.visit['visitRealHours'] = visitHours;
        $scope.visit['Quantity'] = 1;
        if ( $scope.visit.OnlineBookingMinPeopleForEvent > 0 ) {
            $scope.visit['Quantity'] = $scope.visit.OnlineBookingMinPeopleForEvent;
        }
        $scope.visit['PeopleQuantity'] = 1;
        $scope.visit['PriceTotal'] = $scope.visit.TotalPrice;
        $scope.visit['PriceTotalWithoutTax'] = $scope.visit.PriceWithoutTax;

        if ($scope.newBookingBirthday) {
            $scope.minBookableTime = moment().add($scope.PartyBookingOpenAfter, 'hours');
            if ( $scope.PartyBookingOpenAfter > 0 ) {
                $scope.minDate = moment().add($scope.PartyBookingOpenAfter, 'hours');
            }else{
                $scope.minDate = moment();
            }
        }else{
            $scope.minBookableTime = moment().add($scope.BookingOpenAfter, 'hours');
            if ( $scope.BookingOpenAfter > 0 ) {
                $scope.minDate = moment().add($scope.BookingOpenAfter, 'hours');
            }else{
                $scope.minDate = moment();
            }
        }

        
        // $scope.minDate = $scope.currentDate > $scope.minDate ? $scope.currentDate : $scope.minDate;

        // var disabledDaysArray = ["4-5-2021","4-6-2021","4-7-2021","4-8-2021","4-9-2021"];

        var maxTries = 30;
        if($scope.visit.CustomDates.length > 0)
            maxTries = 60;
        
        // Try to find the next date which is allowed by the days filter;
        while (!filterDays($scope.minDate.toDate())[0] && maxTries--) {
            $scope.minDate.add(1, 'days');
        }

        $scope.dontCallCheckConflict = true;
        await $scope.calculatePrice($scope.visit);
        await $scope.getDayHours($scope.minDate);
        const firstDay = $scope.gym[0].Culture == "en-US" ? 0 : 1;
        

        var datepicker = '#newBookingDatepicker' + $scope.currentVisitId;
        var datepickerEl = $('.sessions-list .item[data-itemid="' + visitID + '"]').find(datepicker)
        datepickerEl.datepicker({
            minDate: 0,
            firstDay: firstDay,
            maxDate: $scope.daysAheadBooking,
            dateFormat: "yy-mm-dd",
            onSelect: function (dateText) {
                $scope.ready = false;
                $('.sessions-list .item[data-itemid="' + visitID + '"]').removeClass('loaded');
                var newDateF = moment(dateText);
                $scope.currentTempDate = newDateF;
                $scope.getDayHours(newDateF);
            }
        });
        $('.ui-datepicker').addClass('notranslate');

        $scope.currentDate = moment($scope.currentDate);
        if($scope.currentDate > $scope.minDate){
            datepickerEl.datepicker("setDate", new Date($scope.currentDate));
        }else{
            datepickerEl.datepicker("setDate", new Date($scope.minDate));
        }
        datepickerEl.datepicker("option", "minDate", new Date($scope.minDate));
        datepickerEl.datepicker('option', 'beforeShowDay', filterDays);
        $scope.date = datepickerEl.datepicker('getDate');
        
        function filterDays(date) {
            if (($scope.visit.offDays == 'all' || $scope.visit.offDays === undefined) && $scope.visit.CustomDates.length == 0) return [true, '', ''];
            var day = date.getDay();
            var dayIsAllowed = $scope.visit.offDays.indexOf(day) != -1;
            let newDate = prepareDateToCompare(date);
            newDate = moment(newDate);
            // dayIsAllowed = disabledDays(date);

            if($scope.visit.CustomDates.length > 0){
                for (let index = 0; index < $scope.visit.CustomDates.length; index++) {
                    if( $scope.visit.CustomDates[index].Hours.length > 0 ){   
                        let element = $scope.visit.CustomDates[index];
                        let elDate =  prepareDateToCompare(element.Date);
                        elDate = moment(elDate);

                        if(newDate.isSame(elDate)){
                            dayIsAllowed = true;
                            $scope.daysAheadBooking = null;
                            break;
                        }else{
                            dayIsAllowed = false;
                        }
                    }else{
                        dayIsAllowed = false;
                    }
                }
            }

            if($scope.visit.CustomSlots.length > 0){
                for (let index = 0; index < $scope.visit.CustomSlots.length; index++) {
                    let element = $scope.visit.CustomSlots[index];
                    let elDate =  prepareDateToCompare(element.DateStart);
                    elDate = moment(elDate);

                    if(newDate.isSame(elDate)){
                        if(element.Hours.length > 0){
                            dayIsAllowed = true;
                            break;
                        }else{
                            dayIsAllowed = false;
                        }
                    }
                }
            }
            return [dayIsAllowed, '', ''];
        }
    }

    $(document).on('click', '.sessions-list .item .actions .field-wrap.field-wrap-datepicker i', function(){
        var id = $(this).parent().find('input');

        if ( id.datepicker("widget").is(":visible")){
            console.log('show');
        }else{
            id.datepicker("show");
        }
    })

    $scope.getDayHours = function (now) {
        $scope.selectedIndex = -1;

        var numberDay = moment(now).format('e');
        var ree = $.grep($scope.visit.visitRealHours, function (e) { return e.day == numberDay; });
        $scope.realHours = [];
        $scope.curHours = [];
        if (ree != undefined && ree.length > 0) {
            for (i = 0; i < ree[0].hours[0].length; i++) {
                var justDate = moment(now).startOf('day');
                var justTime = moment(ree[0].hours[0][i], $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                if (moment(dateTime).isAfter($scope.minBookableTime)) {
                    $scope.realHours.push(ree[0].hours[0][i]);
                }
            }
        }
        checkConflict(now);
    }

    function customMagic(data, date){
        data.Hours.sort((a, b) => (a.Time.Hours > b.Time.Hours) ? -1 : (a.Time.Hours === b.Time.Hours) ? ((a.Time.Minutes > b.Time.Minutes) ? -1 : 1) : 1 );

        let hours = [];
        var d = moment('2011-11-11');

        if ( data.Hours.length > 0 ) {
            for (var i = data.Hours.length - 1; i >= 0; i--) {
                var newDateObj = moment(d).add(data.Hours[i].Time.TotalMinutes, 'm').format('HH:mm');
                var justDate = moment(date).startOf('day');
                var justTime = moment(newDateObj, $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                if (moment(dateTime).isAfter($scope.minBookableTime)) {
                    hours.push(newDateObj);    
                }
            }

            if(hours.length > 0){
                $scope.realHours = hours;
            }else{
                $scope.realHours = [];
                $scope.noHours = true;
            }
        }

        if ( data.NoSlots ) {
            $scope.realHours = [];
            $scope.noHours = true;
        }
    }

    async function checkCustomSlots(date){

        let dataObject = {
            VisitDefinitionID: $scope.orderInfo.id,
            Date: date,
            Namespace: $scope.infoData.NameSpace
        }

        await $http({
            method: 'POST',
            url: '/OnlineBooking/GetCustomSlots',
            data: dataObject
        }).success(function (data) {
            if (data)
                customMagic(data,date);

        }).error(function (err) {
            console.log(err);
        });
    }

    function checkForCustomDate(date){
        let customDate = $scope.visit.CustomDates.find((item) => {
            let prepDate = prepareDateToCompare(item.Date);
            return prepDate === date;
        });
        return customDate;
    }

    function prepareDateToCompare(date){
        let checkDate = moment(date);

        checkDate.set({hour:0,minute:0,second:0,millisecond:0})
        // let stringDate = checkDate.getFullYear() + '-' + ('0' + (checkDate.getMonth() + 1)).slice(-2) + '-' + ('0' + checkDate.getDate()).slice(-2);
        // let prepareDate = moment(stringDate);
        let prepareDate = checkDate.toISOString();

        return prepareDate;
    }

    async function checkConflict(b) {
        // Check if there is custom Dates
        let preparedDate = prepareDateToCompare(b);
        if(customDate = checkForCustomDate(preparedDate)){
            customMagic(customDate, b);
        // Else check for custom Slots    
        }else{
            await checkCustomSlots(b);
        }  

        var item = $('.sessions-list .item.expanded');
        var people = item.find('.item-quantity').val();
        // $scope.orderInfo.People = people;
        $scope.notReachMinimumSlots = false;

        $scope.ccData = {};
        $scope.loading = true;

        $scope.ccData.VisitId = item.data('itemid')
        // $scope.ccData.VisitId = $scope.currentVisitId;
        $scope.ccData.StartDate = b;
        if (people < 1)
            $scope.ccData.People = 1;
        else
            $scope.ccData.People = people;
        $scope.ccData.NameSpace = $scope.infoData.NameSpace;
        $scope.ccData.GymID = $scope.infoData.GymID;
        $scope.ccData.IsBirthday = $scope.newBookingBirthday;

        if ($scope.realHours.length > 0) {
            $scope.ccData.StartDate = $scope.realHours.map(function (h) {
                var justDate = moment($scope.ccData.StartDate).startOf('day');
                var month = justDate.month();
                var justTime = moment(h, $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
                if (isDstChangeDay && month == 2){
                    dateTime = dateTime.add(-1, 'hours');
                }else if ( isDstChangeDay ){
                    dateTime = dateTime.add(1, 'hours');
                }

                return dateTime;
            });

            Backend.checkConflictAsync($scope.ccData).then(function success(results) {
                $scope.curHours = _.map(results.data, function (hourData) {
                    return {
                        isConflict: hourData.MaxPeople > 0,
                        areas: hourData.Areas,
                        value: moment(hourData.StartDate).format($scope.timeFormat),
                        slotsleft: hourData.SlotsLeft
                    };
                });

                $scope.maxQuantity = Math.max.apply(Math, $scope.curHours.map(function(o) { return o.slotsleft; }))

                $timeout(function() {
                    if ($scope.curHours.length == 0) {
                        $scope.noHours = true;
                    } else {
                        $scope.noHours = false;
                    }
    
                    if ($scope.oneVisit) {
                        $('body').addClass('loaded');
                    }
                    $scope.loading = false;
                    plusClicked = false;
                }, 10);

                setTimeout(function() {
                    $('.sessions-list .item.expanded').addClass('loaded');
                }, 1000);
            });
        } else {
            if ($scope.oneVisit) {
                $('body').addClass('loaded');
            }
            $timeout(function() {
                $scope.noHours = true;
                $scope.loading = false;
                $scope.curHours = [];
                plusClicked = false;
            }, 10);
            setTimeout(function() {
                $('.sessions-list .item.expanded').addClass('loaded');
            }, 1000);
        }

        $scope.dontCallCheckConflict = false;
    };


    async function checkConflictForHour(date){
        $scope.ccData.StartDate = date;
        let result = false;

        await Backend.checkConflictAsync($scope.ccData).then(function success(results) {

            let slotsLeft = results.data[0].SlotsLeft

            if($scope.orderInfo.People <= slotsLeft){
                result = true;
            }      
        });

        return result;
    }

    $scope.compare = function ($index) {
        var itemPeople = $scope.visit.Quantity;
        if ($index == undefined)
            return;
        $scope.selectedIndex = $index;

        var SelectedItem = $scope.curHours[$index];
        if (SelectedItem != undefined) {
            $scope.visitLimit = SelectedItem.slotsleft;

            if (SelectedItem.isConflict == true) {
                $scope.ready = false;
            } else {
                $scope.orderInfo.Time = $scope.realHours[$index];
                $scope.hours = $scope.realHours;
                $scope.tempAreas = $scope.curHours[$index].areas;

                $scope.maxPeople = $scope.curHours[$index].areas[0].MaxPeople;

                if (itemPeople > 0 && $scope.orderInfo.Time != '' && itemPeople <= $scope.maxPeople) {
                    $scope.notEnoughSlots = false;
                    if ( itemPeople >= $scope.orderInfo.OnlineBookingMinPeopleForEvent ) {
                        $scope.notReachMinimumSlots = false;
                        $scope.ready = true;
                    }else{
                        $scope.notReachMinimumSlots = true;
                        $scope.ready = false;
                    }
                }
                else {
                    $scope.ready = false;
                    $scope.notEnoughSlots = true;
                }
            }
        } else {
            $scope.ready = false;
        }
    }

    $scope.addToCart = function (item) {
        $scope.orderInfo.OnlineBookingWhatToWear = item.OnlineBookingWhatToWear

        if ( $scope.newBookingBirthday == true && $scope.orderInfo.Schedules.length > 0){
            $scope.newBookingBirthdayBooked = true;
        }else{
            $('.sessions-list').addClass('loading');
            $('.sessions-list .item.expanded').removeClass('loaded');
            var datepicker = '#newBookingDatepicker' + item.VisitDefinitionID;
            var date = $(datepicker).val();
            var justDate = moment(date).startOf('day');
            var month = justDate.month();
            var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
            var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
            var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
            if (isDstChangeDay && month == 2){
                dateTime = dateTime.add(-1, 'hours');
            }else if ( isDstChangeDay ){
                dateTime = dateTime.add(1, 'hours');
            }

            $scope.ccData.StartDate = dateTime;

            Backend.checkConflictAsync($scope.ccData).then(function success(results) {

                let slotsLeft = results.data[0].SlotsLeft;

                if($scope.orderInfo.People <= slotsLeft){
                    $scope.orderInfo.Date = moment(dateTime);
                    $scope.orderInfo.StartDate = moment(dateTime);
                    $scope.orderInfo.People = item.Quantity;
                    $scope.orderInfo.ParentsAttending = item.PeopleQuantity;
                    $scope.orderInfo.PriceTotal = item.PriceTotal;
                    $scope.orderInfo.PriceTotalWithoutTax = item.PriceTotalWithoutTax;
                    $scope.orderInfo.VisitID = item.VisitDefinitionID;
                    $scope.selectedIndex = -1;
                    $scope.orderInfo.Capacity = item.Capacity;
                    $scope.currentDate = $scope.currentTempDate;
                    $scope.checkedBeforeAddtoCard = true;
                    $scope.bookVisit($scope.orderInfo);
                    $scope.ready = false;
                }else{
                    let translated = $translateThis('Not Enought Slots');
    
                    Swal.fire({
                        type: 'warning',
                        title: translated,
                    }).then(function(result) {
                        $('.sessions-list').removeClass('loading');
                        $('.sessions-list .item.expanded').addClass('loaded');
                        if (result.value) {
                            // window.location.href = waiverHref;
                        }else{
                            // $timeout(function() {
                            //     
                            // }, 1);
                        }
                    });
                }
            });
        }
    }

    $scope.bookVisit = function (item) {
        var dateLocal = moment(item.Date).format($scope.dateTimeFormat);
        $scope.bookedItem = { VisitID: item.id, VisitName: $scope.visit.VisitName, UniqueID: item.id + dateLocal, people: item.People, Date: item.Date, Price: $scope.visit.PriceCurrent, TotalPrice: $scope.visit.PriceCurrent, PriceWithoutTax: $scope.visit.PriceWithoutTax, Duration: $scope.visit.Duration, DateLocal: dateLocal, DateHour: item.Time, TaxIDs: $scope.visit.TaxIDs, Tax: $scope.visit.TaxPercent, OnlineBookingPictureLink: $scope.visit.OnlineBookingPictureLink, Description: $scope.visit.Description, PriceTotal: item.PriceTotal, PriceTotalWithoutTax: item.PriceTotalWithoutTax, MinimalPackagePriceByPeople: $scope.visit.MinimalPackagePriceByPeople, MinimalPackagePeople: $scope.visit.MinimalPackagePeople, Capacity: item.Capacity, OnlineBookingDiscount: $scope.visit.OnlineBookingDiscount, OnlineBookingDiscountPrice: $scope.visit.OnlineBookingDiscountPrice, OnlineBookingCategoryDiscount: $scope.visit.OnlineBookingCategoryDiscount, ServiceCategoryID: $scope.visit.ServiceCategoryID, quantityDiscount: $scope.visit.quantityDiscount, Price1: $scope.visit.Price1, TaxCash: $scope.visit.TaxCash}

        var result = $.grep($scope.booked, function (e) { return e.UniqueID == $scope.bookedItem.UniqueID; });

        if (result.length > 0) {
            let quantiyToRemove = $scope.booked[0].people;
            $scope.removeByAttr($scope.booked, 'UniqueID', $scope.bookedItem.UniqueID)
            removeQuantityFromDiscCat($scope.bookedItem.ServiceCategoryID, quantiyToRemove);
        }

        addQuantityToDiscCat($scope.bookedItem.ServiceCategoryID, $scope.bookedItem.people);
        $scope.booked.push($scope.bookedItem);

        toSchedules();
    }

    var n = 0;
    var toSchedules = function (bookInfo) {
        $scope.orderInfo.Schedules = [];
        $scope.bookedInfo = $scope.booked.map(function (bookedItem) {
            n++;

            var sessionID = bookedItem.VisitID + bookedItem.VisitName + n;

            return {
                VisitID: bookedItem.VisitID,
                VisitName: bookedItem.VisitName,
                PeopleAttending: bookedItem.people,
                Date: moment(bookedItem.Date).toISOString(),
                DateHourFormated: moment(bookedItem.Date).format($scope.timeFormat),
                Price: bookedItem.TotalPrice,
                Price1: bookedItem.Price1,
                PriceWithoutTax: bookedItem.PriceWithoutTax,
                PriceTotal: bookedItem.PriceTotal,
                PriceTotalWithoutTax: bookedItem.PriceTotalWithoutTax,
                Duration: bookedItem.Duration,
                DateLocal: bookedItem.DateLocal,
                DateHour: bookedItem.DateHour,
                TaxIDs: bookedItem.TaxIDs,
                TaxCash: bookedItem.TaxCash,
                Capacity: bookedItem.Capacity,
                SessionID: sessionID,
                UniqueID: bookedItem.VisitID + bookedItem.DateLocal,
                MinimalPackagePriceByPeople: bookedItem.MinimalPackagePriceByPeople,
                MinimalPackagePeople: bookedItem.MinimalPackagePeople,
                OnlineBookingDiscount: bookedItem.OnlineBookingDiscount,
                OnlineBookingDiscountPrice: bookedItem.OnlineBookingDiscountPrice,
                OnlineBookingCategoryDiscount: bookedItem.OnlineBookingCategoryDiscount,
                ServiceCategoryID: bookedItem.ServiceCategoryID,
                quantityDiscount: bookedItem.quantityDiscount
            };
        });

        if ( !$scope.newBookingBirthday ){
            for(var i = 0; i < $scope.orderInfo.Areas.length; i++) {
                if ($scope.orderInfo.Areas[i].VisitID == $scope.tempAreas[0].VisitID && $scope.orderInfo.Areas[i].DateBegin == $scope.tempAreas[0].DateBegin && $scope.orderInfo.Areas[i].DateEnd == $scope.tempAreas[0].DateEnd) {
                    $scope.orderInfo.Areas.splice(i, 1);
                }
            }
            $scope.orderInfo.Areas.push($scope.tempAreas[0]);
        }else{
            $scope.orderInfo.Areas = $scope.tempAreas;
        }

        $scope.orderInfo.Schedules = $scope.bookedInfo;
        $scope.calculatePrice($scope.visit);
        discountSchedule();
        $scope.getTotal();
        $scope.getTotalWithTax();
        if(!$scope.backEndCartLoading){
            updateBackEndCart($scope.orderInfo);
        }else{
            $('body').addClass('loaded');
            $scope.backEndCartLoading = false;
        }

        if ($scope.orderInfo.Schedules.length > 0) {
            $scope.showCart = true;
        }

        $('.neworder-wrapper.newbooking .shopping-cart').addClass('addOne');
        setTimeout(function() {
            $('.neworder-wrapper.newbooking .shopping-cart').removeClass('addOne');
        }, 820);

        checkCartHeight()
    };

    $scope.getTotal = function () {
        $scope.orderInfo.TotalPriceWithoutTax = 0;

        for (var i = 0; i < $scope.booked.length; i++) {
            if ($scope.booked[i].Discount != undefined && $scope.booked[i].Discount > 0) {
                $scope.booked[i].PriceWithoutTax = $scope.booked[i].PriceWithoutTax - ($scope.booked[i].PriceWithoutTax / 100 * $scope.booked[i].Discount);
            }
            // else if($scope.orderInfo.Discount != true && $scope.booked[i].OnlineBookingDiscount > 0){
            //     $scope.booked[i].PriceTotalWithoutTax = $scope.booked[i].PriceWithoutTax - ($scope.booked[i].PriceWithoutTax / 100 * $scope.booked[i].OnlineBookingDiscount);
            // }
            $scope.orderInfo.TotalPriceWithoutTax += $scope.booked[i].PriceTotalWithoutTax;
        }
        $scope.orderInfo.TotalPriceWithoutTax += $scope.orderInfo.addonsSum;
        $scope.orderInfo.TotalPriceDisc = $scope.orderInfo.TotalPrice;
        $scope.orderInfo.TotalPriceDiscWT = $scope.orderInfo.TotalPriceWT;
    };

    $scope.getTotalWithTax = function () {
        $scope.orderInfo.TotalPrice = 0;

        for (var i = 0; i < $scope.booked.length; i++) {
            if ($scope.booked[i].Discount != undefined && $scope.booked[i].Discount > 0) {
                $scope.booked[i].TotalPrice = $scope.booked[i].TotalPrice - ($scope.booked[i].TotalPrice / 100 * $scope.booked[i].Discount);
            }
            // else if ($scope.orderInfo.Discount != true && $scope.booked[i].OnlineBookingDiscount > 0 ){
            //     $scope.booked[i].PriceTotal = $scope.booked[i].Price - ($scope.booked[i].Price / 100 * $scope.booked[i].OnlineBookingDiscount);
            // }
            $scope.orderInfo.TotalPrice += $scope.booked[i].PriceTotal;
        }
        $scope.orderInfo.TotalPrice += $scope.orderInfo.addonsSumWT;
        $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPrice;
        $scope.orderInfo.TotalPriceDisc = $scope.orderInfo.TotalPrice;
        $scope.orderInfo.TotalPriceDiscWT = $scope.orderInfo.TotalPriceWT;
    };

    function daysInMonth(m, y) { // m is 0 indexed: 0-11
        switch (m) {
            case 1:
                return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
            case 8: case 3: case 5: case 10:
                return 30;
            default:
                return 31
        }
    }


    function isValid(d, m, y) {
        return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
    }

    function populateStorage() {

        $scope.storageInfo = {
            FirstName: $scope.orderInfo.FirstName,
            LastName: $scope.orderInfo.LastName,
            Telephone: $scope.inputInitТPhone.telInput.value,
            TelCode: $scope.inputInitТPhone.selectedDialCode.innerHTML,
            Email: $scope.orderInfo.Email,
        }

        if($scope.newBookingBirthday || $scope.infoData.Settings.SingleVisitChildInput){
            $scope.storageInfo.BirthdayStyle = true;
            $scope.storageInfo.ChildName = $scope.orderInfo.FirstName + " " + $scope.orderInfo.LastName;
            $scope.storageInfo.ChildFirstName = $scope.orderInfo.FirstName;
            $scope.storageInfo.ChildLastName = $scope.orderInfo.LastName;
            $scope.storageInfo.FirstName = $scope.orderInfo.EmergencyName1;
            $scope.storageInfo.LastName = $scope.orderInfo.EmergencyName2;
            $scope.storageInfo.BirthdateChildDay = $scope.clientBirthdayDay;
            $scope.storageInfo.BirthdateChildMonth = $scope.clientBirthdayMonth;
            $scope.storageInfo.BirthdateChildYear = $scope.clientBirthdayYear;
        }

        sessionStorage.setItem('storageinfo', JSON.stringify($scope.storageInfo));
        sessionStorage.setItem('orderinfo', JSON.stringify($scope.orderInfo));
    }

     // Cart Methods
    // GetCart ( int GymID, string Namespace)
    // UpdateCart (string Email, string FirstName, string LastName, string Telephone, List<CartItemModel> Items, int GymID, string Namespace)
    $scope.backEndCartLoading = false;
    function getBackEndCart(){
        let data = {
            GymID: infoData.GymID,
            Namespace: namespace,
            GiftCard: false
        }
    
        $http({
            method: 'GET',
            url: '/onlinebooking/GetCart',
            params: { GiftCard: false, GymID: infoData.GymID, NameSpace: namespace }
        }).success(function (data) {
            let cartItems = data.CartItems
            if(cartItems.length){
                for (let index = 0; index < cartItems.length; index++) {
                    const element = cartItems[index];
                    let elDate = new Date(element.SlotDateTime);
                    let now = new Date();
                    if(elDate > now){
                        $scope.ccData = {
                            GymID: infoData.GymID,
                            IsBirthday: false,
                            NameSpace: namespace,
                            People: element.Quantity,
                            StartDate: elDate,
                            VisitId: element.DefinitionID
                        }
                        Backend.checkConflictAsync($scope.ccData).then(function success(results) {
                            let slotsLeft = results.data[0].SlotsLeft;

                            if(element.Quantity <= slotsLeft){
                                var visitBirthResult = $.grep($scope.birthdays, function (e) { return e.VisitDefinitionID == element.DefinitionID; });
                                var visitResult = $.grep($scope.visits, function (e) { return e.VisitDefinitionID == element.DefinitionID; });

                                if(visitBirthResult.length > 0){
                                    $scope.changeStep(2, 1);
                                    $scope.visit = visitBirthResult[0];
                                }else{
                                    $scope.changeStep(2, 2);
                                    $scope.visit = visitResult[0];
                                }

                                $scope.tempAreas = results.data[0].Areas;

                                var visitHours = [];
                                var vHours = $scope.visit.OnlineBookingHours;
                                var d = moment('2011-11-11'); 

                                $.each(vHours, function (index, value) {
                                    var self = $(this);
                                    var hours = [];

                                    $.each(self[0].Hours, function (index, value) {
                                        var innerSelf = $(this);
                                        var newDateObj = moment(d).add(innerSelf[0].Time.TotalMinutes, 'm').format('HH:mm');
                                        hours.push(newDateObj);
                                    });

                                    var oned = { day: self[0].DayOfWeek, hours: [hours] };

                                    visitHours.push(oned);

                                });

                                $scope.visit['visitRealHours'] = visitHours;
                                console.log($scope.visit);
                                console.log('uyesss');
                                
                                $scope.orderInfo.Date = moment(elDate);
                                $scope.orderInfo.StartDate = moment(elDate);
                                $scope.orderInfo.People = element.Quantity;
                                $scope.orderInfo.ParentsAttending = element.Quantity;
                                $scope.orderInfo.PriceTotal = element.TotalPrice;
                                $scope.orderInfo.PriceTotalWithoutTax = element.TotalPrice;
                                $scope.orderInfo.VisitID = element.DefinitionID;
                                $scope.orderInfo.id = element.DefinitionID;
                                $scope.selectedIndex = -1;
                                $scope.orderInfo.Capacity = slotsLeft;
                                $scope.currentDate = elDate;
                                $scope.checkedBeforeAddtoCard = true;
                                $scope.backEndCartLoading = true;
                                $scope.bookVisit($scope.orderInfo);
                                $scope.ready = false;
                            }else{
                            //    There are no slots left so we dont do anything
                            }
                        })
                    }else{
                        $('body').addClass('loaded');
                    }
                }
            }else{
                $('body').addClass('loaded');
            }
        }).error(function (error) {
            console.log(error);
        });
    }

    // $(window).on('load', function(){
    //     getBackEndCart();
    // })

    function updateBackEndCart(order){
        console.log($scope.orderInfo);

        let dataItems = [];
        for (let index = 0; index < $scope.orderInfo.Schedules.length; index++) {
            const element = $scope.orderInfo.Schedules[index];
            let newItem = {
                DefinitionID: element.VisitID,
                SlotDateTime: element.Date,
                ItemName: element.VisitName,
                // ReceipientFirstName: $scope.orderInfo.FirstName,
                // ReceipientLastName: $scope.orderInfo.LastName,
                // ReceipientEmail: $scope.orderInfo.Email,
                Quantity: element.PeopleAttending,
                Price: element.Price,
                TotalPrice: element.PriceTotal,
                sendGiftCardToThisEmail: false
            }

            dataItems.push(newItem);
        }

        let data = {
            Email: $scope.orderInfo.Email,
            FirstName: $scope.orderInfo.FirstName,
            LastName: $scope.orderInfo.LastName,
            Telephone: $scope.inputInitТPhone.selectedDialCode.innerHTML + $scope.inputInitТPhone.telInput.value,
            Items: dataItems,
            GymID: infoData.GymID,
            Namespace: namespace,
            GiftCard: false
        }
    
        $http({
            method: 'POST',
            url: '/onlinebooking/UpdateCart',
            data: data
        }).success(function (data) {
            console.log(data);
        }).error(function (error) {
            console.log(error);
        });
    }

    $scope.readyToSendMain = true;

    function requireWaiverPopup(data){
        let translated = $translateThis('Waiver Required!');
        if(data.WaiverTitle){
            translated = $translateThis('Waiver Required WaiverName!', { waiverName: data.WaiverTitle });
        }
        let waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + infoData.GymID + '&NameSpace=' + namespace + '&Redirect=/onlinebooking/newbooking';
        Swal.fire({
            type: 'warning',
            title: translated,
            showCancelButton: true,
        }).then(function(result) {
            if (result.value) {

                // Set Info in Session Storage
                populateStorage();

                window.location.href = waiverHref;
            }else{
                // $timeout(function() {
                //     
                // }, 1);
            }
        });
    }

    function sendAddClient(){
        if ( $scope.newBookingBirthday || $scope.infoData.Settings.SingleVisitChildInput ){
            $scope.orderInfo.ChildName = $scope.orderInfo.FirstName + " " + $scope.orderInfo.LastName;
            $scope.orderInfo.ParentName = $scope.orderInfo.EmergencyName1 + " " + $scope.orderInfo.EmergencyName2;
            $scope.orderInfo.EmergencyName = $scope.orderInfo.ParentName;
            $scope.orderInfo.Language = 1;
        }

        if( $scope.newBookingVisit ){
            $scope.paymentPageText = infoData.Settings.PaymentPageText;
            $scope.orderInfo.TotalPriceWOTax = $scope.orderInfo.TotalPriceWithoutTax;
            $scope.orderInfo.Tax = $scope.orderInfo.TotalPrice - $scope.orderInfo.TotalPriceWithoutTax;
        }

        $scope.orderInfo.EmergencyPhone = $scope.inputInitТPhone.selectedDialCode.innerHTML + $scope.inputInitТPhone.telInput.value;
        $scope.orderInfo.EmergencyPhone = $scope.orderInfo.EmergencyPhone.replace(/ /g,'');
        $scope.orderInfo.Valid = true;

        $scope.error = false;
        var data = {
            Email: $scope.orderInfo.Email,
            GymID: infoData.GymID,
            Namespace: namespace
        }

        if ($scope.newBookingBirthday || $scope.infoData.Settings.SingleVisitChildInput ) {
            if (isValid($scope.clientBirthdayDay, $scope.clientBirthdayMonth - 1, $scope.clientBirthdayYear)) {
                $scope.readyToSendMain = true;
                $scope.orderInfo.BirthDate = $scope.clientBirthdayMonth + '-' + $scope.clientBirthdayDay + '-' + $scope.clientBirthdayYear;
            } else {
                $scope.readyToSendMain = false;
            }
        }

        if ($scope.readyToSendMain == true) {
            $http.post('/OnlineBooking/AddClient', $scope.orderInfo)
                .then(function successCallback(response) {
                    if (parseInt(response.data == 0) || response.data == null || response.data < 0) {
                        $scope.error = true;
                        $scope.formRegister.$invalid = false;
                        // $window.location.reload();
                    } else if (response.data > 0) {
                        $scope.orderInfo.ClientID = parseInt(response.data);
                        $scope.error = false;
                        updateBackEndCart($scope.orderInfo);

                        if ( $scope.infoData.Settings.GeneralConditionsText ) {
                            $scope.vaapShow = true;
                            if(redirected && sessionStorage.orderinfo){
                                $scope.changeStep(3);
                                $('body').addClass('loaded');
                                sessionStorage.clear();
                            }
                        }else{
                            $scope.changeStep(4);
                        }
                    }
                }, function (d) {
                    $scope.formRegister.$invalid = false;
                    $scope.error = true;

                    if(redirected && sessionStorage.orderinfo){
                        $('body').addClass('loaded');
                    }
                    // $window.location.reload();
                });
        }
    }

    $scope.sendData = function () {
        let cats = [];
        for (let index = 0; index < $scope.orderInfo.Schedules.length; index++) {
            const element = $scope.orderInfo.Schedules[index];
            cats.push(element.ServiceCategoryID);
        }

        let data = {
            Categories: cats,
            Email: $scope.orderInfo.Email,
            GymID: infoData.GymID,
            Namespace: namespace
        }

        $http({
            method: 'POST',
            url: '/onlinebooking/NeedsWaiver',
            data: data
        }).success(function (data) {
            if(data.IsWaiverRequired){
            // if( data == 'Waiver Required!'){
                requireWaiverPopup(data);
            }else{
                sendAddClient()
            }
        }).error(function (error) {
            console.log(error);
        });
    };

    $scope.removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

    $scope.removeVisit = function (visit, array = false) {

        if(array){
            for (let index = 0; index < visit.length; index++) {
                const element = visit[index];
    
                $scope.removeByAttr($scope.booked, 'UniqueID', element.UniqueID)
                $scope.removeByAttr($scope.orderInfo.Schedules, 'UniqueID', element.UniqueID)
                $scope.orderInfo.ParentsAttending = 0;

                removeQuantityFromDiscCat(element.ServiceCategoryID, element.PeopleAttending);
                discountSchedule();
                $scope.calculatePrice($scope.visit);

                $scope.getTotal();
                $scope.getTotalWithTax();

                if ($scope.orderInfo.Schedules.length == 0) {
                    $scope.showCart = false;
                    $scope.newBookingBirthdayBooked = false;
                    $('body').removeClass('show-shopping-cart');
                    $scope.vaapShow = false;
                    $scope.changeStep(2);
                    $scope.showAddOn = false;
                    $scope.ready = false;
                }
            }
        }else{
            $scope.removeByAttr($scope.booked, 'UniqueID', visit.UniqueID)
            $scope.removeByAttr($scope.orderInfo.Schedules, 'UniqueID', visit.UniqueID)
            $scope.orderInfo.ParentsAttending = 0;

            removeQuantityFromDiscCat(visit.ServiceCategoryID, visit.PeopleAttending);
            discountSchedule();
            $scope.calculatePrice($scope.visit);

            $scope.getTotal();
            $scope.getTotalWithTax();

            if ($scope.orderInfo.Schedules.length == 0) {
                $scope.showCart = false;
                $scope.newBookingBirthdayBooked = false;
                $('body').removeClass('show-shopping-cart');
                $scope.vaapShow = false;
                $scope.changeStep(2);
                $scope.showAddOn = false;
                $scope.ready = false;
            }
        }
    };


    $scope.plusAddon = function (item) {
        item.Quantity++;
        $scope.saveAdd(item);
    };
    $scope.minusAddon = function (item) {
        if (item.Quantity != 0) {
            item.Quantity--;
            $scope.saveAdd(item);
        }
    };

    $scope.saveAdd = function (i) {
        $scope.calculatePrice(i);
        $scope.deleteAdd(i.VisitDefinitionID);
        $scope.item = i;
        $scope.item.Amount = $scope.item.Quantity;

        if ($scope.item.Amount > 0) {
            $scope.item.Total = $scope.item.Amount * $scope.item.PriceWithoutTax;
            $scope.item.TotalWT = $scope.item.Amount * $scope.item.TotalPrice;

            dataShare.addAddon(i);

            if ( $scope.item.ProductID ) {
                // dataShare.addProduct(i);
                $scope.orderInfo.ExtraProducts.push($scope.item);
            }else{
                // dataShare.addAddon(i);
                $scope.orderInfo.ExtraVisits.push($scope.item);
            }

            updateAddonsSum();
            checkCartHeight();
        }
    }

    $scope.deleteAdd = function (k) {
        var key;
        for (key in $scope.adds) {
            if ($scope.adds[key].VisitDefinitionID == k)
                $scope.adds.splice(key, 1);
        }

        for (key in $scope.orderInfo.ExtraProducts) {
            if ($scope.orderInfo.ExtraProducts[key].VisitDefinitionID == k)
                $scope.orderInfo.ExtraProducts.splice(key, 1);
        }

        for (key in $scope.orderInfo.ExtraVisits) {
            if ($scope.orderInfo.ExtraVisits[key].VisitDefinitionID == k)
                $scope.orderInfo.ExtraVisits.splice(key, 1);
        }

        updateAddonsSum();
    };

    var updateAddonsSum = function () {
        $scope.addonsSum = 0;
        $scope.addonsSumWT = 0;
        $scope.Price = 0;

        // $scope.adds = data.addons;
        // $scope.adds = $scope.adds.concat(data.products);

        var i;
        for (i = 0; i < $scope.adds.length; i++) {
            $scope.addonsSum += $scope.adds[i].PriceWithoutTax * $scope.adds[i].Amount;
            $scope.addonsSumWT += $scope.adds[i].TotalPrice * $scope.adds[i].Amount;
        }

        if ($scope.addonsSum > 0) {
            $scope.full = true;
        } else {
            $scope.full = false;
        }

        $scope.Price = $scope.orderInfo.TotalPrice + $scope.addonsSum;

        $scope.orderInfo.addonsSum = $scope.addonsSum;
        $scope.orderInfo.addonsSumWT = $scope.addonsSumWT;
        $scope.orderInfo.Addons = $scope.adds;

        $scope.getTotal();
        $scope.getTotalWithTax();
    };
    updateAddonsSum();

    $scope.reload = function (logo = false) {

        if(infoData.LinkWebsite && logo){
            window.location = infoData.LinkWebsite
        }else{
            let href = window.location.origin + '/onlinebooking/newbooking?GymID=' + infoData.GymID + '&NameSpace=' + infoData.NameSpace;
            if (customCurrency ){
                href += '&customCurrency=';
                href += customCurrency;
            }
            window.location = href;
        }
    }

    // Payment Step
    var startYear = new Date().getFullYear().toString().substr(-2);
    var currentYear = new Number(startYear);
    currentYear += 20;
    $scope.years = [];

    while (startYear <= currentYear) {
        $scope.years.push(startYear++);
    }

    $scope.paySafeInit = false;
    $scope.orderInfo.Valid = true;
    $scope.ZIP = '';
    $scope.orderInfo.PromoCode = '';
    $scope.orderInfo.DiscountPromoCode = 0;
    $scope.promocodeFalse = false;
    $scope.promocodeTrue = false;

    $scope.$watch('e', function (v) {
        if (v == 1) {
            $scope.orderInfo.deposit = true;
        } else {
            $scope.orderInfo.deposit = false;
        }
    });

    $scope.$watch('orderInfo.PaymentType', function (v) {
        $scope.orderInfo.PaymentType = v;
        if (v == 3) {
            let totalPeople = 0;
            for (let index = 0; index < $scope.orderInfo.Schedules.length; index++) {
               totalPeople += $scope.orderInfo.Schedules[index].PeopleAttending;
            }

            if( totalPeople > 1 ){
                $scope.canMembershipPay = false;
            }else{
                $scope.canMembershipPay = true;
            }
        }

        if (v == 4) {
            $('#payNow').addClass('show');
            if (!$scope.paySafeInit) {
                if ($scope.infoData.PaySafeCard == true && $scope.infoData.PaySafeApiKeyFrontEnd != '') {
                    $scope.paySafeInit = true;
                    // Base64 encoded version the Single-use Token API key.
                    // Create the key below by concatenating the API username and password
                    // separated by a colon and Base64-encoding the result
                    var apiKey = $scope.infoData.PaySafeApiKeyFrontEnd;
                    var Enviroment = "TEST";
                    if ($scope.Enviroment == true)
                        Enviroment = "LIVE";
                    var options = {

                        // select the Paysafe test / sandbox environment
                        environment: Enviroment,

                        // set the CSS selectors to identify the payment field divs above
                        // set the placeholder text to display in these fields
                        fields: {
                            cardNumber: {
                                selector: "#cardNumber",
                                placeholder: "Card number"
                            },
                            expiryDate: {
                                selector: "#expiryDate",
                                placeholder: "Expiry date"
                            },
                            cvv: {
                                selector: "#cvv",
                                placeholder: "CVV"
                            }
                        }
                    };

                    paysafe.fields.setup(apiKey, options, function (instance, error) {
                        document.getElementById("payNow").addEventListener("click", async function (event) {

                            // CanBookHere
                            let canbook = await checkConflictBeforeOrder();

                            if(canbook){
                                instance.tokenize(function (instance, error, result) {
                                    $scope.orderLoading = true;
                                    if (error) {
                                        $('.payment-status .error-msg').addClass('show').append('<p>' + error.message + '</p>');
                                        $scope.orderLoading = false;
                                    } else {
                                        $scope.orderInfo.Token = result.token;
                                        $scope.orderInfo.Comment = $scope.svComment;
                                        $scope.placeOrder();
                                    }
                                });
                            }
                        }, false);
                    });
                }
            }
        }
        else {
            $('#payNow').removeClass('show');
            $scope.ShowPaySafe = false;
        }

        if (v == 66) {
            $('#process-payment-btn-hp').addClass('show');
            $('#process-payment-btn-hp').on('click', async function(){

                // CanBookHere
                let canbook = await checkConflictBeforeOrder();

                if(canbook){
                    $('.step-checkout .step-actions').addClass('loading');
                    /**
                     * Configure hosted payments callback.
                    */
                    let price;

                    if ((!$scope.onlyEarnest || $scope.newBookingVisit) && !$scope.orderInfo.deposit) {
                        price = $scope.orderInfo.TotalPrice;
                    }else{
                        price = $scope.orderInfo.Earnest;
                    }

                    $scope.finalBankPrice = price.toFixed(2).split('.').join("");
                    $scope.finalBankPrice = parseInt($scope.finalBankPrice);

                    var hostedPayments = SimplifyCommerce.hostedPayments(
                        function(response) {

                            if ( response.close != true ) {
                                var cardToken = response.cardToken;
                                // TODO: Pass token to the server & use Simplify's API to make a payment
                                $scope.orderInfo.Token = cardToken;
                                $scope.placeOrder();
                            }else{
                                $('.step-checkout .step-actions').removeClass('loading');
                            }
                        },
                        {
                            scKey: infoData.CommBankPublicApiKey,
                            amount: $scope.finalBankPrice,
                            operation: 'create.token',
                            name: infoData.SubscriptionName,
                            description: ''

                        }
                    ).closeOnCompletion();
                    /**
                     * Handle the error response from the server call that
                     * failed to make a payment from the card token.
                     */
                    function apiPaymentErrorHandler() {
                        // re-enable the payment button, so the user can try again.
                        hostedPayments.enablePayBtn();
                        $('.step-checkout .step-actions').removeClass('loading');
                        // TODO: Handle error
                    }

                    
                    $(".neworder-wrapper.newbooking .payment-methods-list label.bank-label button").trigger('click');
                }
            })
        }else{
            $('#process-payment-btn-hp').removeClass('show');
        }


        if (v == 6) {
            $("#process-payment-btn").addClass('show');
            $("#process-payment-btn").on("click", async function () {

                // CanBookHere

                let canbook = await checkConflictBeforeOrder();

                if(canbook){
                    $scope.orderLoading = true;
                    $('.payment-form.cbform, .loader-container.cbform-loader').addClass('loading');
                    // Disable the submit button
                    $("#process-payment-btn").attr("disabled", "disabled");
                    // Generate a card token & handle the response
                    SimplifyCommerce.generateToken({
                        key: infoData.CommBankPublicApiKey,
                        card: {
                            number: $("#cc-number").val(),
                            cvc: $("#cc-cvc").val(),
                            expMonth: $("#cc-exp-month").val(),
                            expYear: $("#cc-exp-year").val()
                        }
                    }, simplifyResponseHandler);
                    // Prevent the form from submitting
                    return false;
                }
            });

            function simplifyResponseHandler(data) {
                var $paymentForm = $("#payment-form");
                // Remove all previous errors
                $(".error").remove();
                // Check for errors
                if (data.error) {
                    // Show any validation errors
                    if (data.error.code == "validation") {
                        var fieldErrors = data.error.fieldErrors,
                            fieldErrorsLength = fieldErrors.length,
                            errorList = "";
                        for (var i = 0; i < fieldErrorsLength; i++) {
                            errorList += "<div class='error'>Field: '" + fieldErrors[i].field +
                                         "' is invalid - " + fieldErrors[i].message + "</div>";
                        }

                        // console.log(errorList);
                        // Display the errors
                        $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + errorList + '</div>');
                    }
                    // Re-enable the submit button
                    $scope.orderLoading = false;
                    $("#process-payment-btn").removeAttr("disabled");
                } else {
                    // The token contains id, last4, and card type
                    var token = data["id"];
                    // Insert the token into the form so it gets submitted to the server
                    $('.payment-form.cbform .payment-status').append("<input type='hidden' name='simplifyToken' value='" + token + "' />");
                    // Submit the form to the server

                    $scope.orderInfo.Token = token;
                    $scope.placeOrder();
                    // $paymentForm.get(0).submit();
                }
                $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
            }
        }else{
            $("#process-payment-btn").removeClass('show');
        }

        if (v == 7) {
            $scope.orderInfo.PaymentProvider = "paylogin";
        }
        if (v == 71) {
            $scope.orderInfo.PaymentProvider = "credit_paydirect";
        }

        if (v == 8) {

            if($scope.orderInfo.TotalPrice != 0){
                $('#stripe-button').addClass('show');

                stripeInit();
            }
        } else {
            $('#stripe-button').removeClass('show');
        }

        if(v == 9){
            $('#elavon-button').addClass('show');
        }else{
            $('#elavon-button').removeClass('show');
        }

        if (v == 3 || v == 10) {
            $scope.orderInfo.Valid = false;
            $scope.membershipPayment = false;
        }else{
            $scope.orderInfo.Valid = true;
            $scope.membershipPayment = false;
        }
    });

    $('#stripe-button').on('click', function (e) {
        e.preventDefault();

        $scope.orderLoading = true;
        $scope.placeOrder();
    })

    $('#elavon-button').on('click', function (e) {
        e.preventDefault();
        $scope.orderLoading = true;
        $scope.placeOrder();
    })

    function initiateLightbox() {

        let url = '/onlinebooking/GenerateTokenVisits/';
        let dataObject = {
            model: $scope.orderInfo,
            GymID: infoData.GymID,
            NameSpace: namespace
        }

        if ( $scope.newBookingBirthday ){
            url = '/onlinebooking/GenerateTokenBirthday/';
            dataObject = {
                birthday: $scope.orderInfo,
                GymID: infoData.GymID,
                NameSpace: namespace
            }
        }

        $http({
            method: 'POST',
            url: url,
            data: dataObject
        }).success(function (data) {
            if( data == 'Error!' || data == 'Error Payment!' || data == 'Error payment no visit!' || data == 'Error Token!'){
                Swal.fire({
                    type: 'warning',
                    title: data,
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.orderLoading = false;   
                        });
                    })
                });
            }else{
                openLightbox(data)
            }
        }).error(function (error) {
            $scope.orderLoading = false;
        });
    }

    function openLightbox(token) {
        var paymentFields = {
            ssl_txn_auth_token: token
        };
        var callback = {
            onError: function (error) {
                Swal.fire({
                    type: 'warning',
                    title: 'error',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.orderLoading = false;   
                        });
                    })
                });

                showResult("error", error,token);
            },
            onCancelled: function () {
                // showResult("cancelled", "",token);
                Swal.fire({
                    type: 'warning',
                    title: 'Cancelled',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.orderLoading = false;   
                        });
                    })
                });
            },
            onDeclined: function (response) {
                showResult("declined", JSON.stringify(response, null, '\t'), token);
                Swal.fire({
                    type: 'warning',
                    title: 'Declined',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.orderLoading = false;   
                        });
                    })
                });
            },
            onApproval: function (response) {
                $scope.orderInfo.ElavonTransactionID = response.ssl_txn_id
                $scope.orderInfo.OrderID = response.ssl_invoice_number
                $scope.sendOrderInfo($scope.orderInfo, url);

                // showResult("approval", JSON.stringify(response, null, '\t'),token);
            }
        };
        PayWithConverge.open(paymentFields, callback);
        return false;
    }

    function showResult(status, msg, token) {
        console.log(status, msg)

        let url = '/onlinebooking/SaveElavonError/';
        let dataObject = {
            Token: token,
            Status: status,
            ExceptionText: msg,
            NameSpace: namespace
        }

        $http({
            method: 'POST',
            url: url,
            data: dataObject
        });
    }


    function stripeInit(){
        // Create a Stripe client.
        $scope.stripe = Stripe($scope.infoData.StripePublishKey);
        // Create an instance of Elements.
        var elements = $scope.stripe.elements();
        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };


        // Create an instance of the card Element.
        // if ($scope.currencyCode == 'EUR') {
        //     $scope.card = elements.create('card', { style: style, hidePostalCode: true });
        // } else {
        //     $scope.card = elements.create('card', { style: style });
        // }

        $scope.card = elements.create('card', {style: style, hidePostalCode: $scope.infoData.HidePostalCode });

        // Add an instance of the card Element into the `card-element` <div>.
        $scope.card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        $scope.stripeErrorHolder = document.getElementById('card-errors');
        $scope.card.addEventListener('change', function(event) {
            if (event.error) {
                $scope.stripeErrorHolder.textContent = event.error.message;
            } else {
                $scope.stripeErrorHolder.textContent = '';
            }
        });
    }

    $scope.membershipPayment = false;
    $scope.membershipPaymentCost = 0;


     //setup before functions
    var typingTimerMembership;                //timer identifier
    var doneTypingIntervalMembership = 2000;  //time in ms, 5 second for example
    var $inputMembership = $('#membershipCardField');
    $scope.membershipCodeValid = true;

    //on keyup, start the countdown
    $inputMembership.on('keyup', function () {
      clearTimeout(typingTimerMembership);
      typingTimerMembership = setTimeout(doneTypingMembership, doneTypingIntervalMembership);
    });

    //on keydown, clear the countdown 
    $inputMembership.on('keydown', function () {
      clearTimeout(typingTimerMembership);
    });

    //user is "finished typing," do something
    function doneTypingMembership () {
      //do something

        if ( $scope.orderInfo.CardNumber == '' ) {
            $scope.membershipCodeValid = true;
        }else{
            if ($scope.orderInfo.PaymentType == 3 && $scope.orderInfo.CardNumber != '' && $scope.orderInfo.CardNumber != undefined) {
                $scope.orderInfo.Valid = false;
                $scope.membershipPayment = false;
                $http.post('/OnlineBooking/ValidateMembership', $scope.orderInfo)
                .then(function successCallback(response) {
                    if (response.data == 'True') {
                        $scope.orderInfo.Valid = true;
                        $scope.membershipCodeValid = true;
                        $scope.membershipPayment = true;
                    } else{
                        $scope.orderInfo.Valid = false;
                        $scope.membershipCodeValid = false;
                        $scope.membershipPayment = false;
                    }
                })
            }
        }
        $scope.$apply();
    }

    //setup before functions
    var typingTimerGiftCard;                //timer identifier
    var doneTypingIntervalGiftCard = 2000;  //time in ms, 5 second for example
    var $inputGiftCard = $('#giftCodeCardField');
    $scope.giftCodeValid = true;
    $scope.giftCodeSuccess = false;

    //on keyup, start the countdown
    $inputGiftCard.on('keyup', function () {
      clearTimeout(typingTimerGiftCard);
      typingTimerGiftCard = setTimeout(doneTypingGiftCard, doneTypingIntervalGiftCard);
    });

    //on keydown, clear the countdown 
    $inputGiftCard.on('keydown', function () {
      clearTimeout(typingTimerGiftCard);
    });

    //user is "finished typing," do something
    function doneTypingGiftCard () {
      //do something

        if ( $scope.orderInfo.GiftCardCode == '' ) {
            $scope.giftCodeValid = true;
        }else{
            if ($scope.orderInfo.PaymentType == 10 && $scope.orderInfo.GiftCardCode != '' && $scope.orderInfo.GiftCardCode != undefined) {
                $scope.orderInfo.Valid = true;
                $scope.giftCodeSuccess = false;
                var dataObject = {
                    Code: $scope.orderInfo.GiftCardCode,
                    Amount: $scope.orderInfo.TotalPrice,
                    GymID: infoData.GymID,
                    Namespace: infoData.NameSpace
                }

                $http.post('/OnlineBooking/ValidateGiftCode', dataObject)
                .then(function successCallback(response) {
                    if (response.data == 'true') {
                        $scope.orderInfo.Valid = true;
                        $scope.giftCodeValid = true;
                        $scope.giftCodeSuccess = true;
                    } else{
                        $scope.orderInfo.Valid = false;
                        $scope.giftCodeValid = false;
                    }
                })
            }
        }
        $scope.$apply();
    }

    $scope.final = [];

    $scope.changePromoStatus = function () {
        $scope.promocodeTrue = false;
    }

    $scope.changePromoCode = function (value) {
        if ( value == 'empty' ) {
            $scope.orderInfo.PromoCode = null;
        }

        if ( $scope.newBookingBirthday ){
            $scope.orderInfo.DiscountPromoCode = 0;

            $scope.final.Price = $scope.orderInfo.TotalPrice;
            $scope.final.PriceWT = $scope.orderInfo.TotalPriceWT;
            $scope.final.PriceDisc = $scope.orderInfo.TotalPriceDisc;
            $scope.final.PriceDiscWT = $scope.orderInfo.TotalPriceDiscWT;

            $scope.promocodeFalse = false;
            $scope.promocodeTrue = false;
            if ($scope.orderInfo.PromoCode != null && $scope.orderInfo.PromoCode.length > 3) {
                $scope.orderInfo.Date = $scope.orderInfo.StartDate;
                $http({
                    method: 'POST',
                    url: '/onlinebooking/ValidatePromoCode',
                    data: $scope.orderInfo
                }).success(function (data) {

                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].VisitID == $scope.orderInfo.VisitID) {
                                $scope.orderInfo.DiscountPromoCode = data[i].Discount;
                            }
                        }
                        if ($scope.orderInfo.DiscountPromoCode > 0) {
                            $scope.final.Price = ($scope.orderInfo.PriceTotal - ($scope.orderInfo.PriceTotal / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSumWT;
                            $scope.final.Price = roundTo($scope.final.Price, 2);

                            $scope.final.PriceWT = ($scope.orderInfo.PriceTotalWithoutTax - ($scope.orderInfo.PriceTotalWithoutTax / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSum;
                            $scope.final.PriceWT = roundTo($scope.final.PriceWT, 2);

                            $scope.final.PriceDisc = ($scope.orderInfo.PriceTotal - ($scope.orderInfo.PriceTotal / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSumWT;
                            $scope.final.PriceDisc = roundTo($scope.final.PriceDisc, 2);

                            $scope.final.PriceDiscWT = ($scope.orderInfo.PriceTotalWithoutTax - ($scope.orderInfo.PriceTotalWithoutTax / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSum;
                            $scope.final.PriceDiscWT = roundTo($scope.final.PriceDiscWT, 2);

                            // $scope.orderInfo.TotalPriceWithoutTax = $scope.final.PriceWT;

                            $scope.promocodeTrue = true;
                            $scope.promocodeFalse = false;
                        } else {
                            if (!$scope.promocodeTrue) {
                                $scope.promocodeTrue = false;
                                $scope.promocodeFalse = true;
                            }
                        }
                    } else {
                        $scope.promocodeFalse = true;
                    }
                }).error(function () {
                });
            }
        }

        if( $scope.newBookingVisit ){
            $scope.promocodeFalse = false;
            $scope.promocodeTrue = false;
            if ($scope.orderInfo.PromoCode != null && $scope.orderInfo.PromoCode.length > 3) {
                 for (let b = 0; b < $scope.orderInfo.Schedules.length; b++) {
                    $scope.orderInfo.Schedules[b].PriceTotalWithoutPC = $scope.orderInfo.Schedules[b].PriceTotal;
                }
                $scope.getTotal();
                $scope.getTotalWithTax();

                $http({
                    method: 'POST',
                    url: '/onlinebooking/ValidatePromoCode',
                    data: $scope.orderInfo
                }).success(function (data) {

                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            for (let b = 0; b < $scope.orderInfo.Schedules.length; b++) {
                                if (data[i].VisitID == $scope.orderInfo.Schedules[b].VisitID) {
                                    $scope.orderInfo.Schedules[b].Discount = data[i].Discount;
                                    if($scope.orderInfo.Schedules[b].Discount === 100){
                                        $scope.orderInfo.Schedules[b].PriceTotalWithoutTax = 0;
                                        $scope.orderInfo.Schedules[b].PriceTotal = 0;
                                        $scope.orderInfo.Schedules[b].PriceOriginal = 0;
                                        $scope.orderInfo.Schedules[b].Price = 0;
                                    }else{

                                        $scope.orderInfo.Schedules[b].PriceTotalWithoutTax = $scope.orderInfo.Schedules[b].PriceTotalWithoutTax - ($scope.orderInfo.Schedules[b].PriceTotalWithoutTax / 100 * data[i].Discount);

                                        $scope.orderInfo.Schedules[b].PriceTotalWithoutTax = roundTo($scope.orderInfo.Schedules[b].PriceTotalWithoutTax, 2);

                                        if($scope.orderInfo.Schedules[b].TaxCash > 0){
                                            $scope.orderInfo.Schedules[b].PriceTotal = $scope.orderInfo.Schedules[b].PriceTotalWithoutTax + ($scope.orderInfo.Schedules[b].TaxCash * $scope.orderInfo.Schedules[b].PeopleAttending);
                                            $scope.orderInfo.Schedules[b].PriceTotal = roundTo($scope.orderInfo.Schedules[b].PriceTotal, 2);

                                            $scope.orderInfo.Schedules[b].PriceOriginal = roundTo($scope.orderInfo.Schedules[b].Price, 2);

                                            $scope.orderInfo.Schedules[b].Price = $scope.orderInfo.Schedules[b].PriceTotalWithoutTax + ($scope.orderInfo.Schedules[b].TaxCash * $scope.orderInfo.Schedules[b].PeopleAttending);
                                            $scope.orderInfo.Schedules[b].Price = roundTo($scope.orderInfo.Schedules[b].Price, 2);
                                        }else{
                                            $scope.orderInfo.Schedules[b].PriceTotal = $scope.orderInfo.Schedules[b].PriceTotal - ($scope.orderInfo.Schedules[b].PriceTotal / 100 * data[i].Discount);
                                            $scope.orderInfo.Schedules[b].PriceTotal = roundTo($scope.orderInfo.Schedules[b].PriceTotal, 2);

                                            $scope.orderInfo.Schedules[b].PriceOriginal = roundTo($scope.orderInfo.Schedules[b].Price, 2);

                                            $scope.orderInfo.Schedules[b].Price = $scope.orderInfo.Schedules[b].Price - ($scope.orderInfo.Schedules[b].Price / 100 * data[i].Discount);
                                            $scope.orderInfo.Schedules[b].Price = roundTo($scope.orderInfo.Schedules[b].Price, 2);
                                        }
                                    }
                                    $scope.promocodeTrue = true;
                                    $scope.promocodeFalse = false;
                                }
                                else {
                                    if (!$scope.promocodeTrue) {
                                        $scope.promocodeTrue = false;
                                        $scope.promocodeFalse = true;
                                    }
                                }
                            }
                            for (let b = 0; b < $scope.booked.length; b++) {
                                if (data[i].VisitID == $scope.booked[b].VisitID) {
                                    $scope.booked[b].Discount = data[i].Discount;
                                    if($scope.booked[b].Discount === 100){
                                        $scope.booked[b].PriceTotalWithoutTax = 0;
                                        $scope.booked[b].TotalPriceOriginal = 0;
                                        $scope.booked[b].PriceTotal = 0;
                                        $scope.booked[b].PriceWithoutTaxOriginal = 0;    
                                    }else{
                                        $scope.booked[b].PriceTotalWithoutTax = $scope.booked[b].PriceTotalWithoutTax - ($scope.booked[b].PriceTotalWithoutTax / 100 * data[i].Discount);
                                        $scope.booked[b].PriceTotalWithoutTax = roundTo($scope.booked[b].PriceTotalWithoutTax, 2);
                                        $scope.booked[b].TotalPriceOriginal = roundTo($scope.booked[b].PriceTotal, 2);

                                        if($scope.booked[b].TaxCash > 0){
                                            $scope.booked[b].PriceTotal =  $scope.booked[b].PriceTotalWithoutTax + ($scope.booked[b].TaxCash * $scope.booked[b].people)
                                            $scope.booked[b].PriceTotal = roundTo($scope.booked[b].PriceTotal, 2);
                                        }else{
                                            $scope.booked[b].PriceTotal = $scope.booked[b].PriceTotal - ($scope.booked[b].PriceTotal / 100 * data[i].Discount);
                                            $scope.booked[b].PriceTotal = roundTo($scope.booked[b].PriceTotal, 2);
                                        }

                                        $scope.booked[b].PriceWithoutTaxOriginal = roundTo($scope.booked[b].PriceWithoutTax, 2);
                                    }
                                    $scope.promocodeTrue = true;
                                    $scope.promocodeFalse = false;
                                } else {

                                    if (!$scope.promocodeTrue) {
                                        $scope.promocodeTrue = false;
                                        $scope.promocodeFalse = true;
                                    }
                                }
                            }
                        }
                        $scope.getTotal();
                        $scope.getTotalWithTax();

                        if($scope.orderInfo.PaymentType == 8 && $scope.orderInfo.TotalPrice == 0 && $scope.promocodeTrue){
                            $('#stripe-button').removeClass('show');
                        }
                    } else {
                        $scope.promocodeFalse = true;
                    }

                }).error(function () {
                });

            }
            else {
                for (let b = 0; b < $scope.orderInfo.Schedules.length; b++) {
                    if ($scope.orderInfo.Schedules[b].PriceOriginal != undefined) {
                        $scope.orderInfo.Schedules[b].Discount = false;
                        $scope.orderInfo.Schedules[b].Price = $scope.orderInfo.Schedules[b].PriceOriginal;
                        $scope.orderInfo.Schedules[b].PriceTotalWithoutTax = $scope.orderInfo.Schedules[b].PriceTotalWithoutPC;
                        $scope.orderInfo.Schedules[b].PriceTotal = $scope.orderInfo.Schedules[b].PriceTotalWithoutPC;
                    }
                }

                for (let l = 0; l < $scope.booked.length; l++) {
                    if ($scope.booked[l].TotalPriceOriginal != undefined) {
                        $scope.booked[l].Discount = false;
                        $scope.booked[l].PriceTotalWithoutTax = $scope.booked[l].people * $scope.booked[l].PriceWithoutTaxOriginal;
                        $scope.booked[l].PriceTotal = $scope.booked[l].TotalPriceOriginal;
                        $scope.booked[l].PriceWithoutTax = $scope.booked[l].PriceWithoutTaxOriginal;
                        $scope.booked[l].TotalPrice = $scope.booked[l].TotalPriceOriginal;
                    }
                }

                $scope.getTotal();
                $scope.getTotalWithTax();
            }
        }
    };

    function orderInfoReset(){
        $scope.curHours = [];
        $scope.realHours = [];
        $scope.orderInfo = {};
        $scope.orderInfo.Time = '';
        $scope.orderInfo.Discount = false;
        $scope.orderInfo.People = 0;
        $scope.orderInfo.ParentsAttending = 0;
        $scope.orderInfo.deposit = false;
        $scope.orderInfo.TotalPrice = 0;
        $scope.orderInfo.TotalPriceWT = 0;
        $scope.orderInfo.TotalPriceDisc = 0;
        $scope.orderInfo.TotalPriceDiscWT = 0;
        $scope.orderInfo.Comment = '';
        $scope.orderInfo.addonsSum = 0;
        $scope.orderInfo.addonsSumWT = 0;
        $scope.orderInfo.Areas = new Array();
        $scope.orderInfo.Schedules = [];
        $scope.orderInfo.Addons = [];
        $scope.orderInfo.GymID = infoData.GymID;
        $scope.orderInfo.NameSpace = namespace;
        $scope.orderInfo.Earnest = infoData.Settings.Earnest;
        $scope.orderInfo.OnlineBookingWhatToWear = '';
        $scope.orderInfo.ParentsAttending = 0;
        $scope.booked = [];
        $scope.showCart = false;
        $scope.newBookingBirthdayBooked = false;
        $scope.orderInfo.ExtraProducts = [];
        $scope.orderInfo.ExtraVisits = [];
        $('.sessions-list .item.expanded').removeClass('expanded loaded');
    }


    async function checkConflictBeforeOrder(){
        let result = false;
        $scope.orderLoading = true;
        let translated = $translateThis('Not Enought Slots For this Event');
        let translatedSecond = $translateThis('We will delete this event and you have to go back and choose other time for it!');

        let fullEvents = [];

        for (let index = 0; index < $scope.orderInfo.Schedules.length; index++) {

            const element = $scope.orderInfo.Schedules[index];
            let data = {
                GymID: $scope.orderInfo.GymID,
                IsBirthday: $scope.newBookingBirthday,
                NameSpace: $scope.orderInfo.NameSpace,
                People: element.PeopleAttending,
                StartDate: element.Date,
                VisitId: element.VisitID
            }

            await Backend.checkConflictAsync(data).then(function success(results) {

                let slotsLeft = results.data[0].SlotsLeft;
                let maxPeople = results.data[0].MaxPeople > 0 ? true : false;
                
                if(maxPeople || element.PeopleAttending > slotsLeft){
                    fullEvents.push(element);
                }
            });
        }

        if(fullEvents.length){
            let titleOfEvents = '';

            for (let index = 0; index < fullEvents.length; index++) {
                const element = fullEvents[index];

                titleOfEvents += element.VisitName + ' ' + element.DateLocal;

                if(index+1 < fullEvents.length)
                    titleOfEvents += '\n';
            }


            const title = `${translated} \n 
                ${titleOfEvents} \n
                ${translatedSecond}`;
            
            Swal.fire({
            type: 'warning',
            title: title
            }).then(function(result) {
                $scope.removeVisit(fullEvents, true);
                $scope.orderLoading = true;
            });
        }else{
            result = true;
        }

        return result;
    }

    var url = '/onlinebooking/bookvisits/';
    $scope.placeOrder = async function(){
        var intentUrl = '/onlinebooking/GeneratePaymentIntentVisits/';
        let lang = $translate.proposedLanguage() || $translate.use();
        let canbook = await checkConflictBeforeOrder();

        if(canbook){
            if ($scope.orderInfo.PaymentType == 71) {
                $scope.orderInfo.PaymentType = 7;
            }
            $scope.orderInfo.Language = lang;

            if ( $scope.newBookingBirthday ){
                $scope.orderInfo.ChildName = $scope.orderInfo.FirstName + " " + $scope.orderInfo.LastName;
                $scope.orderInfo.ParentName = $scope.orderInfo.EmergencyName1 + " " + $scope.orderInfo.EmergencyName2;
                $scope.orderInfo.EmergencyName = $scope.orderInfo.ParentName;
                $scope.orderInfo.Language = 1;
                $scope.orderInfo.MyPosLanguage = lang;
                url = '/onlinebooking/SaveBirthDay/';
                intentUrl = '/onlinebooking/GeneratePaymentIntentBirthday/'
            }

            if($scope.infoData.Settings.SingleVisitChildInput ){
                $scope.orderInfo.ChildName = $scope.orderInfo.FirstName + " " + $scope.orderInfo.LastName;
                $scope.orderInfo.ParentName = $scope.orderInfo.EmergencyName1 + " " + $scope.orderInfo.EmergencyName2;
                $scope.orderInfo.EmergencyName = $scope.orderInfo.ParentName;
            }

            prepareDataToSend();

            if ($scope.orderInfo.PaymentType == 8) {
                generatePaymentIntent(intentUrl);
            }else if($scope.orderInfo.PaymentType == 9 && $scope.orderInfo.TotalPrice != 0){
                initiateLightbox();
            }else{
                $scope.sendOrderInfo($scope.orderInfo, url);
            }
        }
    }

    function post_to_url(params, method, url) {
        let path = $scope.infoData.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
        if(url){
            path = url;
        }
		method = method || "post";
	
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

    // Generate PaymentInted for Stripe
	function generatePaymentIntent(intentUrl) {

        let dataObject = {
            model: $scope.orderInfo,
            GymID: infoData.GymID,
            NameSpace: namespace
        }

        if ( $scope.newBookingBirthday ){
            dataObject = {
                birthday: $scope.orderInfo,
                GymID: infoData.GymID,
                NameSpace: namespace
            }
        }

        $http({
            method: 'POST',
            url: intentUrl,
            data: dataObject
        }).success(function (data) {

            if(data != 'Error Payment!'){
                $scope.orderInfo.PaymentIntentID = data.ID;
            
                if($scope.orderInfo.TotalPrice != 0){
                    stripeConfirmCard(data);
                }else{
                    $scope.sendOrderInfo($scope.orderInfo, url);
                }
            }else{
                $scope.stripeErrorHolder.textContent = data;
                $scope.orderSent = false;
                $scope.orderLoading = false;
            }   
        }).error(function (error) {
            $scope.stripeErrorHolder.textContent = error.ExceptionMessage;
            $scope.orderSent = false;
            $scope.orderLoading = false;
            
        });
    }
    
    function stripeConfirmCard(data){

		let name = $scope.orderInfo.FirstName + ' ' + $scope.orderInfo.LastName;

		$scope.stripe.confirmCardPayment(data.ClientSecret, {
			payment_method: {
				card: $scope.card,
				  billing_details: {
					name: name
				  }
			}
		}).then(function(result) {
			if (result.error) {
                // Show error to your customer (e.g., insufficient funds)
                $scope.stripeErrorHolder.textContent = result.error.message;
                
                $timeout(function() {
                    $scope.orderSent = false;
                    $scope.orderLoading = false;   
                }, 100);
			} else {
				  // The payment has been processed!
				  if (result.paymentIntent.status === 'succeeded') {
					$scope.sendOrderInfo($scope.orderInfo, url);
					// Show a success message to your customer
					// There's a risk of the customer closing the window before callback
					// execution. Set up a webhook or plugin to listen for the
					// payment_intent.succeeded event that handles any business critical
					// post-payment actions.
				  }
			}
		});
	}

    function prepareDataToSend(){
        $scope.PaymentIntentID = 0;
        $scope.sendOrderFail = false;
        $scope.showCart = false;
        $scope.orderLoading = true;

        var justDate = moment($scope.orderInfo.StartDate).startOf('day');
        var month = justDate.month();
        var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
        var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');

        $scope.orderSent = true;
        if ($scope.orderInfo.Schedules.length > 0) {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPriceWithoutTax;
        } else {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPrice;
        }

        if ($scope.orderInfo.DiscountPromoCode > 0 && $scope.orderInfo.deposit === false && $scope.onlyEarnest !== true) {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPriceWithoutTax - ($scope.orderInfo.TotalPriceWithoutTax / 100 * $scope.orderInfo.DiscountPromoCode);
        }
        

        var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
        if (isDstChangeDay && month == 2){
            dateTime = dateTime.add(-1, 'hours');
        }else if ( isDstChangeDay ){
            dateTime = dateTime.add(1, 'hours');
        }

        $scope.orderInfo.StartDate = moment(dateTime).format($scope.dateTimeFormat).toString();

        if ($scope.orderInfo.deposit === false && $scope.onlyEarnest !== true){
            $scope.orderInfo.Earnest = 0;
        }else{
            $scope.orderInfo.Earnest = infoData.Settings.Earnest;
            $scope.orderInfo.DiscountPromoCode = 0;
            //data.PromoCode = '';
        }
    }

    $scope.sendOrderInfo = function (data, url) {  

        if ( $scope.membershipPayment ) {
            data.PriceTotal = 0
            data.PriceTotalWithoutTax = 0
            data.TotalPrice = 0
            data.TotalPriceDisc = 0
            data.TotalPriceDiscWT = 0
            data.TotalPriceWOTax = 0
            data.TotalPriceWT = 0
            data.TotalPriceWithoutTax = 0
            data.addonsSum = 0
            data.addonsSumWT = 0

            if (data.Schedules.length > 0) {
                for (var i = 0; i < data.Schedules.length; i++) {
                    data.Schedules[i].Price = 0;
                    data.Schedules[i].PriceTotal = 0;
                    data.Schedules[i].PriceTotalWithoutTax = 0;
                    data.Schedules[i].PriceWithoutTax = 0;
                }
            }
        }else{
            data.PriceTotal = roundTo(data.PriceTotal, 2);
            data.PriceTotalWithoutTax = roundTo(data.PriceTotalWithoutTax, 2);
            data.TotalPrice = roundTo(data.TotalPrice, 2);
            data.TotalPriceDisc = roundTo(data.TotalPriceDisc, 2);
            data.TotalPriceDiscWT = roundTo(data.TotalPriceDiscWT, 2);
            data.TotalPriceWOTax = roundTo(data.TotalPriceWOTax, 2);
            data.TotalPriceWT = roundTo(data.TotalPriceWT, 2);
            data.TotalPriceWithoutTax = roundTo(data.TotalPriceWithoutTax, 2);
            data.addonsSum = roundTo(data.addonsSum, 2);
            data.addonsSumWT = roundTo(data.addonsSumWT, 2);

            if (data.Schedules.length > 0) {
                for (var i = 0; i < data.Schedules.length; i++) {
                    data.Schedules[i].Price = roundTo(data.Schedules[i].Price, 2);;
                    data.Schedules[i].PriceTotal = roundTo(data.Schedules[i].PriceTotal, 2);;
                    data.Schedules[i].PriceTotalWithoutTax = roundTo(data.Schedules[i].PriceTotalWithoutTax, 2);;
                    data.Schedules[i].PriceWithoutTax = roundTo(data.Schedules[i].PriceWithoutTax, 2);;
                }
            }
        }

        if($scope.orderInfo.TotalPrice == 0 && ( $scope.orderInfo.PaymentType == 9) ){
            data.PaymentType = 0
        }

        if( $scope.newBookingVisit ){
            $scope.paymentPageText = infoData.Settings.PaymentPageText;
            $scope.orderInfo.TotalPriceWOTax = $scope.orderInfo.TotalPriceWithoutTax;
            $scope.orderInfo.TotalPriceWOTax = roundTo($scope.orderInfo.TotalPriceWOTax, 2);

            $scope.orderInfo.Tax = $scope.orderInfo.TotalPrice - $scope.orderInfo.TotalPriceWithoutTax;
            $scope.orderInfo.Tax = roundTo($scope.orderInfo.Tax, 2);

            
            // for (var i = 0; i < $scope.orderInfo.Schedules.length; i++) {
            //     if ($scope.orderInfo.Schedules[i].Discount && $scope.orderInfo.Schedules[i].OnlineBookingDiscount > 0 ){
            //         $scope.orderInfo.Schedules[i].Price = $scope.orderInfo.Schedules[i].Price - ($scope.orderInfo.Schedules[i].Price / 100 * $scope.orderInfo.Schedules[i].OnlineBookingDiscount);
            //     }
            // }
            $scope.orderInfo.Valid = true;
        }

        let dataObject = {
            model: data,
            GymID: infoData.GymID,
            NameSpace: namespace
        }

        if ( $scope.newBookingBirthday ){
            dataObject = {
                birthday: data,
                GymID: infoData.GymID,
                NameSpace: namespace
            }
        }

        $http({
            method: 'POST',
            url: url,
            data: dataObject
        }).then(function (d) {
            if (d.data === '' || d.data.toString().indexOf('Error') !== -1) {
                $scope.fail = d.data;
                $scope.changeStep(6);
                $scope.orderLoading = false;
            } else if (typeof d.data === 'string' || d.data instanceof String) {
                if ($scope.orderInfo.PaymentType == "4" || $scope.orderInfo.PaymentType == "6" || $scope.orderInfo.PaymentType == "66") {
                    $('.payment-status .error-msg').addClass('show').append('<p>' + d.data + '</p>');
                    $scope.orderSent = false;
                    $scope.orderLoading = false;
                }
                else {
                    $window.location.href = d.data;
                }
            }
            else {
                if($scope.orderInfo.PaymentType == 12 && $scope.orderInfo.TotalPrice != 0){
                    let myPosData = $scope.newBookingVisit ? d.data.MyPosValues : d.data;
                    post_to_url(myPosData, 'post');
                }else if($scope.orderInfo.PaymentType == 14 && $scope.orderInfo.TotalPrice != 0){
                    let netCashData = $scope.newBookingVisit ? d.data.NetCashValues : d.data;
                    post_to_url(netCashData, 'post', 'https://paynow.netcash.co.za/site/paynow.aspx');
                }else if($scope.orderInfo.PaymentType == 13){
                    let paymoblink = d.data.PaymobIframeLink;
                    window.location.href = paymoblink;
                }else{
                    $scope.backInfo = d.data;
                    var realSchedules = [];
                    var addOns = [];

                    var schedules = d.data.Schedules;

                    if ( schedules.length > 0 ) {
                        for (var i = 0; i < schedules.length; i++) {
                            schedules[i].TotalPrice = schedules[i].PeopleAttending*schedules[i].Price;
                            if ( schedules[i].MainVisit == true ) {
                                schedules[i].Date = moment(schedules[i].Date).format($scope.dateTimeFormat);   
                                schedules[i].DateEnd = moment(schedules[i].DateEnd).format($scope.dateTimeFormat);
                                schedules[i].DateStart = moment(schedules[i].DateStart).format($scope.dateTimeFormat);
                                realSchedules.push(schedules[i]);
                            }else{
                                addOns.push(schedules[i]);
                            }
                        }
                    }

                    $scope.backInfo.DateEnd = moment($scope.backInfo.DateEnd).format($scope.dateTimeFormat);
                    $scope.backInfo.DateStart = moment($scope.backInfo.DateStart).format($scope.dateTimeFormat);

                    $scope.backInfo.Schedules = realSchedules;
                    $scope.backInfo.addOns = addOns;

                    if ($scope.backInfo.Schedules && $scope.backInfo.Schedules.length > 0)
                        $scope.backInfo.Tax = $scope.backInfo.TotalPrice - $scope.backInfo.TotalPriceWithoutTax;
                    else {
                        $scope.backInfo.Tax = $scope.backInfo.TotalPriceWithProducts - $scope.backInfo.TotalPriceWithoutTax;
                    }

                    if ($scope.backInfo.IsBirthday) {
                        $scope.backInfo.visit = 'Birthday Booking';
                        $scope.backInfo.Tax = $scope.backInfo.TotalPriceWithProducts - $scope.backInfo.TotalPriceWithoutTax;
                    }
                    else {
                        $scope.backInfo.visit = 'Session Booking';
                        $scope.visits = true;
                        $scope.backInfo.Tax = $scope.backInfo.TotalPrice - $scope.backInfo.TotalPriceWithoutTax;
                    }

                    $scope.backInfo.type = 'Card';
                    $scope.changeStep(5);
                    $scope.orderLoading = false;
                }
            }
        }, function () {
            $scope.sendOrderFail = true;
            $scope.orderSent = false;
            $scope.loading = false;
        });

    };

    $scope.orderLoading = false;

    if ( FailedPayment == true ) {
        $scope.currentStep = 6;
        $('body').addClass('loaded');
    }

    if ( orderID != null && !FailedPayment ) {
        $scope.backInfo = [];
        $scope.currentStep = 5;
        $scope.bank = false;
        $scope.card = true;

        $http({
            method: 'GET',
            url: '/onlinebooking/GetBookigByOrderID/',
            params: { OrderID: orderID, GymID: params.GymID, NameSpace: namespace }
        }).then(function (data) {

            $scope.backInfo = data.data;

            if ( $scope.backInfo.Finished == false ) {
                $scope.currentStep = 6;

                setTimeout(function() {
                    $('body').addClass('loaded');
                }, 1000);
            }else{
                var realSchedules = [];
                var addOns = [];

                var schedules = data.data.Schedules;

                if ( schedules.length > 0 ) {
                    for (var i = 0; i < schedules.length; i++) {
                        schedules[i].TotalPrice = schedules[i].PeopleAttending*schedules[i].Price;
                        if ( schedules[i].MainVisit == true ) {
                            schedules[i].Date = moment(schedules[i].Date).format($scope.dateTimeFormat);   
                            schedules[i].DateEnd = moment(schedules[i].DateEnd).format($scope.dateTimeFormat);
                            schedules[i].DateStart = moment(schedules[i].DateStart).format($scope.dateTimeFormat);
                            realSchedules.push(schedules[i]);
                        }else{
                            addOns.push(schedules[i]);
                        }

                    }
                }

                $scope.backInfo.DateEnd = moment($scope.backInfo.DateEnd).format($scope.dateTimeFormat);
                $scope.backInfo.DateStart = moment($scope.backInfo.DateStart).format($scope.dateTimeFormat);

                $scope.backInfo.Schedules = realSchedules;
                $scope.backInfo.addOns = addOns;

                if ($scope.backInfo.IsBirthday) {
                    $scope.backInfo.visit = 'Birthday Booking';
                    $scope.backInfo.Tax = $scope.backInfo.TotalPriceWithProducts - $scope.backInfo.TotalPriceWithoutTax;
                }
                else {
                    $scope.backInfo.visit = 'Session Booking';
                    $scope.visits = true;
                    $scope.backInfo.Tax = $scope.backInfo.TotalPrice - $scope.backInfo.TotalPriceWithoutTax;
                }

                $scope.backInfo.type = 'Card';

                setTimeout(function() {
                    $('body').addClass('loaded');
                }, 1000);
            }

        });
    }
    
    $('.newbooking-body .neworder-wrapper.newbooking a.menu-trigger').on('click', function(e){
        e.preventDefault();

        $('body').toggleClass('show-menu');
    })

    $('.shopping-cart').on('click', function(e){
        e.preventDefault()

        $(window).scrollTop(0);
        $('body').toggleClass('show-shopping-cart');
    })

    $('.neworder-wrapper .cart-box .cart-actions strong').on('click', function(){
        if ( $('.newbooking-body').is('.show-shopping-cart') ) {
            $('.newbooking-body').removeClass('show-shopping-cart');
        }
    })

    $scope.whatToWearPopup = function(){
        $translate('What to wear')
        .then(function (translatedValue) {
            Swal.fire({
                title: translatedValue,
                html: $scope.orderInfo.OnlineBookingWhatToWear,
            })
        });
    }

    function calcPopupHeight(){
        let windowHeight = $(window).height();
        let popupHeight = $('.login-popup .popup .section-authorize').height();

        if(popupHeight + 40 >= windowHeight){
            $('.login-popup .popup').addClass('overflowScroll');
        }else{
            $('.login-popup .popup').removeClass('overflowScroll');
        }
    }
    
    $scope.loginModal = function () {
		$scope.modalLoading = true;

		$('#login-popup').addClass('show');
        $('#login-popup .popup').addClass('show');
        calcPopupHeight();
		$timeout(function() {
			$scope.modalLoading = false;        
		}, 100);
    }
    
    $scope.closePopup = function () {
		$('.popup-wrapper, #shcedule-popup .success-msg').removeClass('show');
		$('.popup-wrapper .popup-body').find('input').val('');
		$scope.formLoaded = true;
		$('#shcedule-popup .success-msg').removeClass('green');
    }

    $('.popup-wrapper .close, .popup-wrapper .popup-overlay').on('click', function (e) {
		$scope.closePopup();
    })

    function getURLParameter(name) {
        return decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]);
    }
    function hideURLParams() {
        //Parameters to hide (ie ?success=value, ?error=value, etc)
        var hide = ['OrderID'];
        for(var h in hide) {
            if(getURLParameter(h)) {
                history.replaceState(null, document.getElementsByTagName("title")[0].innerHTML, window.location.pathname);
            }
        }
    }

    function visitDefinitionPredefined(){
        if(visitDefinitionID){
            $scope.visitDefinitionID = visitDefinitionID;
            $scope.oneVisit = true;
            let allVisit = $scope.visits.concat($scope.birthdays);

            // Find the current visit
            let visit = allVisit.find((item) => item.VisitDefinitionID === visitDefinitionID);
            
            // Check if is Birthday or Single Visit
            if(visit.OnlineBookingBirthday){
                $scope.changeStep(2, 1);
            }else{
                $scope.changeStep(2, 2);
            }

            // Prepare Minimal Time for Booking and Current Date
            $scope.minBookableTime = $scope.newBookingBirthday ? moment().add($scope.PartyBookingOpenAfter, 'hours') : moment().add($scope.BookingOpenAfter, 'hours');
            var now = new Date($scope.minBookableTime);
            $scope.currentDate = $scope.currentDate > now ? $scope.currentDate : now;

            // Show only the Pre selected Item
            setTimeout(function() {
                let item = $('.sessions-list .item[data-itemid="' + visitDefinitionID + '"]');
                item.addClass('expanded').siblings().addClass('hidden').removeClass('expanded loaded');

                $scope.getVisitHours(visitDefinitionID);
                $scope.selectedIndex = -1;
                
            }, 1000);
        }
    }

    $(window).on('load', function(){
        if ( orderID != null ) {
            hideURLParams();
        }

        if ($scope.Language.indexOf('bg') > -1){
            // element.datepicker( "option", $.datepicker.regional[ "bg" ] );
            $.datepicker.setDefaults( $.datepicker.regional[ "bg" ] );
        }else if ($scope.Language.indexOf('pl') > -1){
            // element.datepicker( "option", $.datepicker.regional[ "pl" ] );
            $.datepicker.setDefaults( $.datepicker.regional[ "pl" ] );
        }else if ($scope.Language.indexOf('pt') > -1){
            // element.datepicker( "option", $.datepicker.regional[ "pl" ] );
            $.datepicker.setDefaults( $.datepicker.regional[ "pt" ] );
        }else if ($scope.Language.indexOf('esn') > -1 || $scope.Language.indexOf('euq') > -1){
            // element.datepicker( "option", $.datepicker.regional[ "es" ] );
            $.datepicker.setDefaults( $.datepicker.regional[ "es" ] );
        }else if($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('glc') > -1){
            $.datepicker.setDefaults( $.datepicker.regional[ "ca" ] );
        }
        else{
            $.datepicker.setDefaults( $.datepicker.regional[ "" ] );
        }

        if(visitDefinitionID){
            $scope.oneVisit = true;
        }

        if ( FailedPayment == false && orderID == null && !$scope.oneVisit && sessionStorage.orderinfo == undefined ) {
            $('body').addClass('loaded');
        }

        if( $(".newbooking #Telephone").length ){
            let phoneLang = getLanguage($scope.gym[0].Culture);
            var inputInitТPhone = document.querySelector("#Telephone");
            
            $scope.inputInitТPhone = window.intlTelInput(inputInitТPhone, {
                autoHideDialCode: false,
                preferredCountries: [phoneLang],
                separateDialCode: true
            });

            if( client != null ){
                $scope.inputInitТPhone.setNumber(client.Telephone);
                $scope.EmergencyPhone = $scope.inputInitТPhone.telInput.value;
            }

            inputInitТPhone.addEventListener("countrychange", function() {
                let countryinfo = $scope.inputInitТPhone.getSelectedCountryData()
                if(countryinfo.dialCode == '44'){
                    $scope.phoneFormat = /^[0-9]{5,11}$/;
                }else{
                    $scope.phoneFormat = /^[0-9]{5,15}$/;
                    $scope.waiverForm.Telephone.$validate()
                }
            });

        }

        if(redirected && sessionStorage.orderinfo){
            var obj = JSON.parse(sessionStorage.orderinfo);
            var storageinfo = JSON.parse(sessionStorage.storageinfo); 
            var teltemp = storageinfo.TelCode + storageinfo.Telephone;
            $scope.inputInitТPhone.setNumber(teltemp);
            
            $timeout(function() {
                $scope.orderInfo = obj;
                $scope.clientBirthdayDay = storageinfo.BirthdateChildDay;
                $scope.clientBirthdayMonth = storageinfo.BirthdateChildMonth;
                $scope.clientBirthdayYear = storageinfo.BirthdateChildYear;
                sendAddClient();
                if(storageinfo.BirthdayStyle){  
                    $scope.newBookingBirthday = true;
                    $scope.newBookingVisit = false;
                }else{
                    $scope.newBookingBirthday = false;
                    $scope.newBookingVisit = true;
                }
                $scope.showAddOn = true;

                if ($scope.orderInfo.Schedules.length > 0) {
                    $scope.showCart = true;
                }
            });
        }else if (redirected && sessionStorage.orderinfo == undefined){
            let url = window.location.href;
            let newUrl = url.split("&Redirected=true")[0];
            window.location.href = newUrl;
        }else{
            getBackEndCart();
        }

    }).on('resize', function(){
        calcPopupHeight();
    });

    // Get Language from backend settings
	function getLanguage(culture){
        let lang = culture.split('-');
		lang = lang[1].toLowerCase();
		return lang;
	}

    function checkCartHeight(){
        var visibleWindowHeight = $(window).height() - 420;
        var cartHeight = $('.neworder-wrapper .cart-box .cart-body ul').height() + 100;

        if ( $(window).width() > 900 ) {
            if ( cartHeight > visibleWindowHeight ){
                $('.neworder-wrapper.newbooking .inner-wrapper .cart-box .cart-body').addClass('scroll').css('max-height', visibleWindowHeight);
            }else{
                $('.neworder-wrapper.newbooking .inner-wrapper .cart-box .cart-body').removeClass('scroll').css('max-height', 'initial');
            }
        }else{
            $('.neworder-wrapper.newbooking .inner-wrapper .cart-box .cart-body').removeClass('scroll').css('max-height', 'initial');
        }
    }

    $(window).on('load resize', function(){
        checkCartHeight()
    })

}]);